(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 34);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("tslib");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("gl-matrix");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.diff = exports.dot = exports.xyz2thetaphi = exports.thetaphi2xyz = exports.square = exports.range = exports.clamp = void 0;
function clamp(x, a, b) {
    return x < a ? a : (x > b ? b : x);
}
exports.clamp = clamp;
function range(start, end) {
    if (end === undefined) {
        end = start;
        start = 0;
    }
    var a = [];
    for (var i = start; i < end; ++i) {
        a.push(i);
    }
    return a;
}
exports.range = range;
function square(x) {
    return x * x;
}
exports.square = square;
function thetaphi2xyz(theta, phi) {
    var ct = Math.cos(theta);
    return [ct * Math.cos(phi), ct * Math.sin(phi), Math.sin(theta)];
}
exports.thetaphi2xyz = thetaphi2xyz;
function xyz2thetaphi(x, y, z) {
    var r2 = x * x + y * y;
    if (r2 === 0) {
        return [z > 0 ? Math.PI / 2 : -Math.PI / 2, 0];
    }
    else {
        var PI2 = 2 * Math.PI;
        var phi = (Math.atan2(y, x) + PI2) % PI2;
        var theta = Math.atan2(z, Math.sqrt(r2));
        return [theta, phi];
    }
}
exports.xyz2thetaphi = xyz2thetaphi;
function dot(a, b) {
    return (a[0] * b[0] +
        a[1] * b[1] +
        a[2] * b[2]);
}
exports.dot = dot;
function diff(a, b) {
    return [
        a[0] - b[0],
        a[1] - b[1],
        a[2] - b[2]
    ];
}
exports.diff = diff;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("@hscmap/gl-wrapper");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
var math_1 = __webpack_require__(2);
var Layer = /** @class */ (function () {
    function Layer() {
    }
    Layer.prototype.changeGlobe = function (globe) {
        this.globe && this.onRemove();
        this.globe = globe;
        if (globe) {
            this.onAdd();
            globe.requestRefresh();
        }
    };
    Layer.prototype.onAdd = function () { };
    Layer.prototype.onRemove = function () { };
    Layer.prototype.render = function (view) { };
    Layer.prototype.active = function () {
        return !!this.globe;
    };
    Layer.baseAlpha = function (view) {
        return 1 - this.overlayAlpha(view);
    };
    Layer.overlayAlpha = function (view) {
        var b = this.overlayAlphaStart;
        var a = this.overlayAlphaGradient;
        return math_1.clamp((view.camera.arc - b) * a, 0, 1);
    };
    Layer.overlayAlphaStart = 0.2;
    Layer.overlayAlphaGradient = 4;
    return Layer;
}());
exports.Layer = Layer;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@hscmap/angle");

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.zeroTexture = exports.loadImage = void 0;
var ImageRequestQueue = /** @class */ (function () {
    function ImageRequestQueue() {
        this.nParallel = 2;
        this.q = [];
        this.running = 0;
    }
    ImageRequestQueue.prototype.push = function (url, failover) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.q.push({ url: url, resolve: resolve, reject: reject, failover: failover });
            _this.consume();
        });
    };
    ImageRequestQueue.prototype.consume = function () {
        var _this = this;
        if (this.rafId === undefined) {
            this.rafId = requestAnimationFrame(function () {
                _this.rafId = undefined;
                if (_this.q.length > 0 && _this.running < _this.nParallel) {
                    var _a = _this.q.shift(), url = _a.url, resolve_1 = _a.resolve, reject_1 = _a.reject, failover_1 = _a.failover;
                    var img_1 = new Image();
                    img_1.onload = function () {
                        --_this.running;
                        resolve_1(img_1);
                        _this.consume();
                    };
                    img_1.onerror = function (e) {
                        --_this.running;
                        if (failover_1) {
                            resolve_1(failover_1);
                        }
                        else {
                            reject_1(e);
                        }
                        _this.consume();
                    };
                    if (url.match(/^(https?:)?\/\//)) {
                        img_1.crossOrigin = '';
                    }
                    img_1.src = url;
                    ++_this.running;
                }
            });
        }
    };
    return ImageRequestQueue;
}());
var qs = new Map();
function loadImage(url, failover) {
    var host = extractHost(url);
    if (!qs.has(host)) {
        qs.set(host, new ImageRequestQueue());
    }
    var q = qs.get(host);
    return q.push(url, failover);
}
exports.loadImage = loadImage;
function extractHost(url) {
    var m = url.match(/https?:\/\/(.*?)\//);
    return m ? m[1] : '';
}
var ctx = document.createElement('canvas').getContext('2d');
exports.zeroTexture = ctx.createImageData(1, 1);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobePointerEvent = exports.PointerEventLayer = void 0;
var tslib_1 = __webpack_require__(0);
var gl_matrix_1 = __webpack_require__(1);
var inertial_mouse_1 = __webpack_require__(9);
var layer_1 = __webpack_require__(4);
var PointerEventLayer = /** @class */ (function (_super) {
    tslib_1.__extends(PointerEventLayer, _super);
    function PointerEventLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastHit = false;
        return _this;
    }
    PointerEventLayer.prototype.hover = function (e) { };
    PointerEventLayer.prototype.enter = function (e) { };
    PointerEventLayer.prototype.leave = function (e) { };
    PointerEventLayer.prototype.dragStart = function (e) { };
    PointerEventLayer.prototype.drag = function (e) { };
    PointerEventLayer.prototype.dragEnd = function (e) { };
    PointerEventLayer.prototype.offset = function (_a) {
        var x = _a.x, y = _a.y;
        var rect = this.globe.canvas.domElement.getBoundingClientRect();
        return {
            x: x - rect.left,
            y: y - rect.top,
        };
    };
    PointerEventLayer.initGlobe = function (globe) {
        globe.addLayer(new PointerEventInitiatorLayer());
    };
    PointerEventLayer.prototype._hover = function (e) {
        var hit = this.hit(e);
        this.hover(e);
        if (this.lastHit !== hit) {
            this.lastHit = hit;
            if (hit) {
                this.enter(e);
                return true;
            }
            else {
                this.leave(e);
            }
        }
    };
    return PointerEventLayer;
}(layer_1.Layer));
exports.PointerEventLayer = PointerEventLayer;
var GlobePointerEvent = /** @class */ (function (_super) {
    tslib_1.__extends(GlobePointerEvent, _super);
    function GlobePointerEvent(e, globe, view) {
        var _this = _super.call(this, e.e) || this;
        _this.globe = globe;
        _this.view = view;
        _this.coord = globe.canvas.coordFromClientCoord(e);
        return _this;
    }
    GlobePointerEvent.prototype.coord2offset = function (coord) {
        var p = gl_matrix_1.vec4.transformMat4(gl_matrix_1.vec4.create(), tslib_1.__spreadArrays(coord.xyz, [1]), this.view.camera.pv);
        var x = p[0] / p[3];
        var y = p[1] / p[3];
        // const z = p[2] / p[3]
        var rect = this.globe.canvas.domElement.getBoundingClientRect();
        return [
            rect.width * (x + 1) / 2.,
            rect.height * (1 - (y + 1) / 2.),
        ];
    };
    return GlobePointerEvent;
}(inertial_mouse_1.SinglePointerEvent));
exports.GlobePointerEvent = GlobePointerEvent;
var PointerEventInitiatorLayer = /** @class */ (function (_super) {
    tslib_1.__extends(PointerEventInitiatorLayer, _super);
    function PointerEventInitiatorLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pointerPressed = false;
        _this.pointerEventLayers = [];
        _this.refreshPointEventLayers = function () {
            _this.pointerEventLayers =
                layers(_this.globe).filter(function (l) { return l instanceof PointerEventLayer; }).reverse();
        };
        return _this;
    }
    PointerEventInitiatorLayer.prototype.render = function (view) {
        this.view = view;
    };
    PointerEventInitiatorLayer.prototype.onAdd = function () {
        var _this = this;
        var clear;
        this.unbindDown = inertial_mouse_1.SinglePointerEvent.bindDown(this.canvas, function (downSe) {
            var activeLayer;
            var downGe = new GlobePointerEvent(downSe, _this.globe, _this.view);
            _this.pointerPressed = true;
            _this.globe.ee.emit('pointer-down', downGe);
            for (var _i = 0, _a = _this.pointerEventLayers; _i < _a.length; _i++) {
                var l = _a[_i];
                if (l.hit(downGe)) {
                    activeLayer = l;
                    break;
                }
            }
            if (activeLayer) {
                activeLayer.dragStart(new GlobePointerEvent(downSe, _this.globe, _this.view));
                var unbindMove_1 = inertial_mouse_1.SinglePointerEvent.bindMove(document, function (moveEvent) {
                    activeLayer.drag(new GlobePointerEvent(moveEvent, _this.globe, _this.view));
                });
                clear = function (cancelEvent) {
                    _this.pointerPressed = false;
                    activeLayer.dragEnd(new GlobePointerEvent(cancelEvent, _this.globe, _this.view));
                    unbindUp_1();
                    unbindMove_1();
                    clear = undefined;
                };
                var unbindUp_1 = inertial_mouse_1.SinglePointerEvent.bindUp(document, function (upSe) {
                    var upGe = new GlobePointerEvent(upSe, _this.globe, _this.view);
                    _this.globe.ee.emit('pointer-up', upGe);
                    clear(upSe);
                });
            }
        }, function (se) {
            clear && clear(se);
        });
        this.unbindHover = inertial_mouse_1.SinglePointerEvent.bindMove(this.canvas, function (se) {
            if (!_this.pointerPressed) {
                var e = new GlobePointerEvent(se, _this.globe, _this.view);
                for (var _i = 0, _a = _this.pointerEventLayers; _i < _a.length; _i++) {
                    var l = _a[_i];
                    if (l._hover(e)) {
                        break;
                    }
                }
            }
        });
        this.globe.ee.addListener('layer-change', this.refreshPointEventLayers);
    };
    PointerEventInitiatorLayer.prototype.onRemove = function () {
        this.globe.ee.removeListener('layer-change', this.refreshPointEventLayers);
        this.unbindHover();
        this.unbindDown();
    };
    Object.defineProperty(PointerEventInitiatorLayer.prototype, "canvas", {
        get: function () {
            return this.globe.canvas.domElement;
        },
        enumerable: false,
        configurable: true
    });
    return PointerEventInitiatorLayer;
}(layer_1.Layer));
function layers(globe) {
    var ls = [];
    globe.eachLayer(function (l) { return ls.push(l); });
    return ls;
}
// function unfocus() {
//   document.activeElement && (document.activeElement as HTMLElement).blur()
// }


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.path = exports.tile = exports.hips = void 0;
var tslib_1 = __webpack_require__(0);
var globe_1 = __webpack_require__(37);
Object.defineProperty(exports, "Globe", { enumerable: true, get: function () { return globe_1.Globe; } });
var layer_1 = __webpack_require__(4);
Object.defineProperty(exports, "Layer", { enumerable: true, get: function () { return layer_1.Layer; } });
var view_1 = __webpack_require__(23);
Object.defineProperty(exports, "View", { enumerable: true, get: function () { return view_1.View; } });
var matrilx_utils_1 = __webpack_require__(11);
Object.defineProperty(exports, "CameraMode", { enumerable: true, get: function () { return matrilx_utils_1.CameraMode; } });
Object.defineProperty(exports, "normalizeZenith", { enumerable: true, get: function () { return matrilx_utils_1.normalizeZenith; } });
Object.defineProperty(exports, "cameraMatrix", { enumerable: true, get: function () { return matrilx_utils_1.cameraMatrix; } });
var angle_1 = __webpack_require__(5);
Object.defineProperty(exports, "EquatorialCoord", { enumerable: true, get: function () { return angle_1.EquatorialCoord; } });
Object.defineProperty(exports, "Angle", { enumerable: true, get: function () { return angle_1.Angle; } });
var animation_1 = __webpack_require__(22);
Object.defineProperty(exports, "Animation", { enumerable: true, get: function () { return animation_1.Animation; } });
var hips = tslib_1.__importStar(__webpack_require__(26));
exports.hips = hips;
var tile = tslib_1.__importStar(__webpack_require__(57));
exports.tile = tile;
var path = tslib_1.__importStar(__webpack_require__(15));
exports.path = path;
var billboard_renderer_1 = __webpack_require__(30);
Object.defineProperty(exports, "BillboardRenderer", { enumerable: true, get: function () { return billboard_renderer_1.BillboardRenderer; } });
var constellation_layer_1 = __webpack_require__(69);
Object.defineProperty(exports, "ConstellationLayer", { enumerable: true, get: function () { return constellation_layer_1.ConstellationLayer; } });
var hipparcos_catalog_layer_1 = __webpack_require__(72);
Object.defineProperty(exports, "HipparcosCatalogLayer", { enumerable: true, get: function () { return hipparcos_catalog_layer_1.HipparcosCatalogLayer; } });
var grid_layer_1 = __webpack_require__(77);
Object.defineProperty(exports, "GridLayer", { enumerable: true, get: function () { return grid_layer_1.GridLayer; } });
var eso_milky_way_layer_1 = __webpack_require__(78);
Object.defineProperty(exports, "EsoMilkyWayLayer", { enumerable: true, get: function () { return eso_milky_way_layer_1.EsoMilkyWayLayer; } });
var pan_layer_1 = __webpack_require__(16);
Object.defineProperty(exports, "PanLayer", { enumerable: true, get: function () { return pan_layer_1.PanLayer; } });
var touch_layer_1 = __webpack_require__(25);
Object.defineProperty(exports, "TouchLayer", { enumerable: true, get: function () { return touch_layer_1.TouchLayer; } });
var zoom_layer_1 = __webpack_require__(20);
Object.defineProperty(exports, "ZoomLayer", { enumerable: true, get: function () { return zoom_layer_1.ZoomLayer; } });
var roll_layer_1 = __webpack_require__(24);
Object.defineProperty(exports, "RollLayer", { enumerable: true, get: function () { return roll_layer_1.RollLayer; } });
var point_event_layer_1 = __webpack_require__(7);
Object.defineProperty(exports, "PointEventLayer", { enumerable: true, get: function () { return point_event_layer_1.PointerEventLayer; } });
Object.defineProperty(exports, "PointEvent", { enumerable: true, get: function () { return point_event_layer_1.GlobePointerEvent; } });
var utils = tslib_1.__importStar(__webpack_require__(82));
exports.utils = utils;
var text2imagedata_1 = __webpack_require__(32);
Object.defineProperty(exports, "text2imageData", { enumerable: true, get: function () { return text2imagedata_1.text2imageData; } });
var image_1 = __webpack_require__(6);
Object.defineProperty(exports, "zeroTexture", { enumerable: true, get: function () { return image_1.zeroTexture; } });


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SinglePointerEvent_1 = __webpack_require__(17);
Object.defineProperty(exports, "SinglePointerEvent", { enumerable: true, get: function () { return SinglePointerEvent_1.SinglePointerEvent; } });
var v2_1 = __webpack_require__(10);
Object.defineProperty(exports, "V2", { enumerable: true, get: function () { return v2_1.V2; } });
var physics_1 = __webpack_require__(18);
Object.defineProperty(exports, "Physics", { enumerable: true, get: function () { return physics_1.Physics; } });
var inertial_mouse_1 = __webpack_require__(38);
Object.defineProperty(exports, "InertialMouse", { enumerable: true, get: function () { return inertial_mouse_1.InertialMouse; } });


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.V2 = void 0;
var V2 = /** @class */ (function () {
    function V2(x, y) {
        this.x = x;
        this.y = y;
    }
    V2.prototype.clone = function () { return new V2(this.x, this.y); };
    return V2;
}());
exports.V2 = V2;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.cameraMatrix = exports.normalizeZenith = exports.izenith3 = exports.zenith3 = exports.CameraMode = exports.composite = void 0;
var gl_matrix_1 = __webpack_require__(1);
function composite(scales, matrices) {
    var m = gl_matrix_1.mat4.fromValues(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    for (var i = 0; i < scales.length; ++i) {
        gl_matrix_1.mat4.multiplyScalarAndAdd(m, m, matrices[i], scales[i]);
    }
    // @ts-ignore
    return m;
}
exports.composite = composite;
var CameraMode;
(function (CameraMode) {
    CameraMode["GNOMONIC"] = "GNOMONIC";
    CameraMode["STEROGRAPHIC"] = "STEREOGRAPHIC";
    CameraMode["FLOATING_EYE"] = "FLOATING_EYE";
})(CameraMode = exports.CameraMode || (exports.CameraMode = {}));
function zenith4(m, a, d, p) {
    // mat4.rotateZ(m, m, -p)
    // mat4.rotateY(m, m, -(Math.PI / 2 - d))
    // mat4.rotateZ(m, m, -a)
    // return m
    var cA = Math.cos(a);
    var sA = Math.sin(a);
    var cP = Math.cos(p);
    var sP = Math.sin(p);
    var cD = Math.cos(d);
    var sD = Math.sin(d);
    gl_matrix_1.mat4.mul(m, m, gl_matrix_1.mat4.fromValues(cA * cP * sD - sA * sP, -cA * sD * sP - cP * sA, cA * cD, 0, cA * sP + cP * sA * sD, cA * cP - sA * sD * sP, cD * sA, 0, -cD * cP, cD * sP, sD, 0, 0, 0, 0, 1));
    return m;
}
function zenith3(a, d, p) {
    var cA = Math.cos(a);
    var sA = Math.sin(a);
    var cP = Math.cos(p);
    var sP = Math.sin(p);
    var cD = Math.cos(d);
    var sD = Math.sin(d);
    return gl_matrix_1.mat3.fromValues(cA * cP * sD - sA * sP, -cA * sD * sP - cP * sA, cA * cD, cA * sP + cP * sA * sD, cA * cP - sA * sD * sP, cD * sA, -cD * cP, cD * sP, sD);
}
exports.zenith3 = zenith3;
function izenith3(a, d, p) {
    var cA = Math.cos(a);
    var sA = Math.sin(a);
    var cP = Math.cos(p);
    var sP = Math.sin(p);
    var cD = Math.cos(d);
    var sD = Math.sin(d);
    return gl_matrix_1.mat3.fromValues(cA * cP * sD - sA * sP, cA * sP + cP * sA * sD, -cD * cP, -cA * sD * sP - cP * sA, cA * cP - sA * sD * sP, cD * sP, cA * cD, cD * sA, sD);
}
exports.izenith3 = izenith3;
function zenith2adp(m) {
    var d = Math.asin(m[8]);
    var a = Math.atan2(m[5], m[2]);
    var p = Math.atan2(m[7], -m[6]);
    return [a, d, p];
}
function normalizeZenith(a, d, z) {
    return zenith2adp(zenith3(a, d, z));
}
exports.normalizeZenith = normalizeZenith;
function cameraMatrix(p) {
    var out = gl_matrix_1.mat4.create();
    look(out, p);
    zenith4(out, p.za, p.zd, p.zp);
    return out;
}
exports.cameraMatrix = cameraMatrix;
function look(out, p) {
    var fovy = p.fovy;
    var ar = p.aspectRatio;
    var cA = Math.cos(p.phi);
    var sA = Math.sin(p.phi);
    var cD = Math.cos(p.theta);
    var sD = Math.sin(p.theta);
    var sR = Math.sin(p.roll);
    var cR = Math.cos(p.roll);
    switch (p.mode) {
        case CameraMode.GNOMONIC:
            return gl_matrix_1.mat4.set(out, (cA * sD * sR + cR * sA) / (ar * fovy), (-cA * cR * sD + sA * sR) / fovy, 41 * cA * cD / 39, cA * cD, (-cA * cR + sA * sD * sR) / (ar * fovy), -(cA * sR + cR * sA * sD) / fovy, 41 * cD * sA / 39, cD * sA, -cD * sR / (ar * fovy), cD * cR / fovy, 41 * sD / 39, sD, 0, 0, -4 / 39, 0);
        case CameraMode.STEROGRAPHIC:
            return gl_matrix_1.mat4.set(out, 2 * (cA * sD * sR + cR * sA) / (ar * fovy), 2 * (-cA * cR * sD + sA * sR) / fovy, 13 * cA * cD / 11, cA * cD, 
            // tslint:disable-next-line:max-line-length
            2 * (-cA * cR + sA * sD * sR) / (ar * fovy), -(2 * cA * sR + 2 * cR * sA * sD) / fovy, 13 * cD * sA / 11, cD * sA, -2 * cD * sR / (ar * fovy), 2 * cD * cR / fovy, 13 * sD / 11, sD, 0, 0, 7 / 11, 1);
        case CameraMode.FLOATING_EYE:
            return gl_matrix_1.mat4.set(out, 
            // tslint:disable-next-line:max-line-length
            (fovy + 1) * (cA * sD * sR + cR * sA) / (ar * fovy), (fovy + 1) * (-cA * cR * sD + sA * sR) / fovy, 41 * cA * cD / 39, cA * cD, 
            // tslint:disable-next-line:max-line-length
            (fovy + 1) * (-cA * cR + sA * sD * sR) / (ar * fovy), -(fovy + 1) * (cA * sR + cR * sA * sD) / fovy, 41 * cD * sA / 39, cD * sA, -cD * sR * (fovy + 1) / (ar * fovy), cD * cR * (fovy + 1) / fovy, 41 * sD / 39, sD, 0, 0, 41 * fovy / 39 - 20 / 39, fovy);
    }
}


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = require("@hscmap/cache-map");

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable:variable-name
// TODO: cleanup !!
Object.defineProperty(exports, "__esModule", { value: true });
exports.size2order = exports.encode_id = exports.decode_id = exports.shiftmapId = exports.shiftmap = exports.coeff = void 0;
var PI = Math.PI;
var PI2 = 2 * Math.PI;
var PI_2 = Math.PI / 2;
var PI_4 = Math.PI / 4;
var PI_8 = Math.PI / 8;
exports.coeff = (function () {
    var i2xy = (function () {
        function index2xy(index) {
            var i = Math.floor(index / 4);
            var j = index % 4;
            var mesh = [0, 1 / 3, 2 / 3, 1];
            return [mesh[i], mesh[j]];
        }
        var a = [];
        for (var i = 0; i < 16; ++i) {
            a.push(index2xy(i));
        }
        return a;
    })();
    var za = [new Float32Array(16), new Float32Array(16), new Float32Array(16)];
    var zb = [new Float32Array(16), new Float32Array(16), new Float32Array(16)];
    var zeromat4 = new Float32Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    return function (order, ipix) {
        var nside = 1 << order;
        var d = PI_4 / nside;
        var _a = nest2fxy(nside, ipix), f = _a.f, x = _a.x, y = _a.y;
        var _b = fxy2tu(nside, f, x, y), t0 = _b.t, u0 = _b.u;
        var belt = Math.abs(u0) <= PI_4;
        var isBeltEnd = (f < 4 || 8 <= f) && x + y === nside - 1;
        if (isBeltEnd) {
            for (var i = 0; i < 16; ++i) {
                var _c = i2xy[i], p = _c[0], q = _c[1];
                var t = t0 + d * (1 - q - p);
                var u = u0 + d * (p - q);
                var zaNorth = tu2za(t, u, f >= 8);
                var zaSouth = tu2za(t, u, f < 4);
                var va = za2vec(zaNorth.z, zaNorth.a);
                var vb = za2vec(zaSouth.z, zaSouth.a);
                za[0][i] = va[0];
                za[1][i] = va[1];
                za[2][i] = va[2];
                zb[0][i] = vb[0];
                zb[1][i] = vb[1];
                zb[2][i] = vb[2];
            }
            var a = [mul(B, za[0]), mul(B, za[1]), mul(B, za[2])];
            var b = [mul(B, zb[0]), mul(B, zb[1]), mul(B, zb[2])];
            return { a: a, b: b };
        }
        else {
            for (var i = 0; i < 16; ++i) {
                var _d = i2xy[i], p = _d[0], q = _d[1];
                var t = t0 + d * (1 - q - p);
                var u = u0 + d * (p - q);
                // tslint:disable-next-line:no-shadowed-variable
                var _e = tu2za(t, u, belt), z = _e.z, a_1 = _e.a;
                var va = za2vec(z, a_1);
                za[0][i] = va[0];
                za[1][i] = va[1];
                za[2][i] = va[2];
            }
            var a = [mul(B, za[0]), mul(B, za[1]), mul(B, za[2])];
            var b = [zeromat4, zeromat4, zeromat4];
            return { a: a, b: b };
        }
    };
})();
function fxy2tu(nside, f, x, y) {
    var f_row = f >> 2;
    var f1 = f_row + 2;
    var f2 = 2 * (f % 4) - (f_row % 2) + 1;
    var v = x + y;
    var h = x - y;
    var i = f1 * nside - v - 1;
    var k = (f2 * nside + h + (8 * nside));
    var t = k / nside * PI_4;
    var u = PI_2 - i / nside * PI_4;
    return { t: t, u: u };
}
function tu2za(t, u, belt) {
    var abs_u = Math.abs(u);
    if (belt) {
        var z = u / (3 * PI_8);
        var a = t;
        return { z: z, a: a };
    }
    else {
        if (abs_u >= PI_2) {
            return { z: sign(u), a: 0 };
        }
        var t_t = t % (Math.PI / 2);
        var a = t - (abs_u - PI_4) / (abs_u - PI_2) * (t_t - PI_4);
        var z = sign(u) * (1 - 1 / 3 * square(2 - 4 * abs_u / PI));
        return { z: z, a: a };
    }
}
function za2vec(z, a) {
    var z2 = z * z;
    var sin_theta = z2 > 1 ? -Math.sqrt(z2 - 1) : Math.sqrt(1 - z2);
    var x = sin_theta * Math.cos(a);
    var y = sin_theta * Math.sin(a);
    return [x, y, z];
}
function mul(a, b) {
    var l = b.length;
    var c = new Float32Array(l);
    for (var i = 0; i < l; ++i) {
        var p = 0;
        for (var j = 0; j < l; ++j) {
            p += a[i + j * l] * b[j];
        }
        c[i] = p;
    }
    return c;
}
function dot(a, b) {
    var c = 0;
    for (var i = 0; i < a.length; ++i) {
        c += a[i] * b[i];
    }
    return c;
}
function ab2v(a, b, p, q, isBeltEnd) {
    var p2 = p * p;
    var p3 = p2 * p;
    var q2 = q * q;
    var q3 = q2 * q;
    if (isBeltEnd) {
        return p - q >= 0 ?
            a.map(function (aa) { return dot([p3, p2, p, 1], mul(aa, [q3, q2, q, 1])); }) :
            b.map(function (bb) { return dot([p3, p2, p, 1], mul(bb, [q3, q2, q, 1])); });
    }
    else {
        return a.map(function (aa) { return dot([p3, p2, p, 1], mul(aa, [q3, q2, q, 1])); });
    }
}
function beltEnd(nside, ipix) {
    var nside2 = nside * nside;
    var f = Math.floor(ipix / nside2);
    var _a = bit_decombine(ipix % nside2), x = _a.x, y = _a.y;
    return (f < 4 || 8 <= f) && x + y === nside - 1;
}
function shiftmap(order, ipix, size) {
    function encode(v) {
        var VMAX = 0.015;
        return ((v / VMAX) + 1) / 2 * 256;
    }
    var nside = 1 << order;
    var _a = exports.coeff(order, ipix), a = _a.a, b = _a.b;
    var d = new Uint8Array(3 * size * size);
    var isBeltEnd = beltEnd(nside, ipix);
    function dpq(p, q) {
        var v = ab2v(a, b, p, q, isBeltEnd);
        var _a = vec2pixcoord(nside, ipix, v), x = _a.x, y = _a.y;
        var trueP = y;
        var trueQ = 1 - x;
        return [p - trueP, q - trueQ];
    }
    var k = 0;
    for (var i = 0; i < size; ++i) {
        var q = i / (size - 1);
        for (var j = 0; j < size; ++j) {
            var p = j / (size - 1);
            var _b = dpq(p, q), dp = _b[0], dq = _b[1];
            d[3 * k + 0] = encode(dp);
            d[3 * k + 1] = encode(dq);
            d[3 * k + 2] = 0;
            ++k;
        }
    }
    return d;
}
exports.shiftmap = shiftmap;
function shiftmapId(order, index) {
    var nside = 1 << order;
    var nside2 = nside * nside;
    var f0 = Math.floor(index / nside2);
    var f = (f0 >> 2) << 2;
    var index2 = f * nside2 + (index % nside2);
    return encode_id(order, index2);
}
exports.shiftmapId = shiftmapId;
function vec2pixcoord(nside, ipix, v) {
    var n2 = nside * nside;
    var face = Math.floor(ipix / n2);
    var _a = vec2za(v[0], v[1], v[2]), z = _a.z, a0 = _a.a;
    var a = wrap(a0 - (face % 4 + 2.5) * PI_2, PI2) - PI + (face % 4 + 0.5) * PI_2;
    var _b = zaf2tu(z, a, face), t = _b.t, u = _b.u;
    var cfxy = nest2fxy(nside, ipix);
    var ctu = fxy2tu(nside, cfxy.f, cfxy.x, cfxy.y);
    var d = PI_4 / nside;
    var dt = (face % 4 === 1 || face % 4 === 2) ?
        wrap(t, PI2) - wrap(ctu.t, PI2) :
        wrap(t + PI, PI2) - wrap(ctu.t + PI, PI2);
    var du = u - ctu.u + d;
    return {
        x: (dt + du) / d / 2,
        y: (du - dt) / d / 2,
    };
}
function vec2za(x, y, z) {
    var r2 = x * x + y * y;
    if (r2 === 0) {
        return { z: z < 0 ? -1 : 1, a: 0 };
    }
    else {
        var a = (Math.atan2(y, x) + PI2) % PI2;
        z /= Math.sqrt(z * z + r2);
        return { z: z, a: a };
    }
}
function nest2fxy(nside, ipix) {
    var nside2 = nside * nside;
    var f = Math.floor(ipix / nside2); // base pixel index
    var k = ipix % nside2; // nested pixel index in base pixel
    var _a = bit_decombine(k), x = _a.x, y = _a.y;
    return { f: f, x: x, y: y };
}
function sigma(z) {
    if (z < 0) {
        return -sigma(-z);
    }
    else {
        return 2 - Math.sqrt(3 * (1 - z));
    }
}
function zaf2tu(z, a, f) {
    if (Math.abs(z) <= 2. / 3.) { // equatorial belt
        var t = a;
        var u = 3 * PI_8 * z;
        return { t: t, u: u };
    }
    else { // polar caps
        f %= 4;
        // a = clamp(a, f * PI_2, (f + 1) * PI_2)
        var p_t = a - (f * PI_2);
        var sigma_z = sigma(z);
        var t = a - (Math.abs(sigma_z) - 1) * (p_t - PI_4);
        var u = PI_4 * sigma_z;
        return { t: t, u: u };
    }
}
function wrap(x, p) {
    return x < 0 ? p - (-x % p) : x % p;
}
function square(x) {
    return x * x;
}
var sign = Math.sign || (function (x) {
    return x > 0 ? 1 : (x < 0 ? -1 : 0);
});
function bit_decombine(p) {
    assert(p <= 0x7fffffff);
    // (python)
    // ' | '.join(f'(p & 0x{2**(2*i):x}) >> {i}' for i in range(16))
    var x = (p & 0x1) >> 0 | (p & 0x4) >> 1 | (p & 0x10) >> 2 |
        (p & 0x40) >> 3 | (p & 0x100) >> 4 | (p & 0x400) >> 5 |
        (p & 0x1000) >> 6 | (p & 0x4000) >> 7 | (p & 0x10000) >> 8 |
        (p & 0x40000) >> 9 | (p & 0x100000) >> 10 | (p & 0x400000) >> 11 |
        (p & 0x1000000) >> 12 | (p & 0x4000000) >> 13 | (p & 0x10000000) >> 14 | (p & 0x40000000) >> 15;
    // (python)
    // ' | '.join(f'(p & 0x{2**(2*i + 1):x}) >> {i+1}' for i in range(15))
    var y = (p & 0x2) >> 1 | (p & 0x8) >> 2 | (p & 0x20) >> 3 |
        (p & 0x80) >> 4 | (p & 0x200) >> 5 | (p & 0x800) >> 6 |
        (p & 0x2000) >> 7 | (p & 0x8000) >> 8 | (p & 0x20000) >> 9 |
        (p & 0x80000) >> 10 | (p & 0x200000) >> 11 | (p & 0x800000) >> 12 |
        (p & 0x2000000) >> 13 | (p & 0x8000000) >> 14 | (p & 0x20000000) >> 15;
    return { x: x, y: y };
}
function decode_id(id) {
    assert(id <= 0x7fffffff);
    var order = 0;
    var l = (id >> 2) + 1;
    while (l >= 4) {
        l >>= 2;
        ++order;
    }
    var index = id - (((1 << (2 * order)) - 1) << 2);
    return { order: order, index: index };
}
exports.decode_id = decode_id;
function encode_id(order, index) {
    return 4 * ((1 << (2 * order)) - 1) + index;
}
exports.encode_id = encode_id;
function assert(condition) {
    console.assert(condition);
    if (!condition) {
        debugger;
    }
}
function size2order(size) {
    var n = 0;
    while (size > 0) {
        size >>= 1;
        ++n;
    }
    return n;
}
exports.size2order = size2order;
var B = new Float32Array([
    81 / 4, -81 / 2, 99 / 4, -9 / 2, -81 / 2, 81, -99 / 2, 9, 99 / 4, -99 / 2, 121 / 4, -11 / 2, -9 / 2, 9, -11 / 2, 1,
    -243 / 4, 243 / 2, -297 / 4, 27 / 2, 405 / 4, -405 / 2, 495 / 4, -45 / 2, -81 / 2, 81, -99 / 2, 9, 0, 0, 0, 0,
    243 / 4, -243 / 2, 297 / 4, -27 / 2, -81, 162, -99, 18, 81 / 4, -81 / 2, 99 / 4, -9 / 2, 0, 0, 0, 0,
    -81 / 4, 81 / 2, -99 / 4, 9 / 2, 81 / 4, -81 / 2, 99 / 4, -9 / 2, -9 / 2, 9, -11 / 2, 1, 0, 0, 0, 0,
    -243 / 4, 405 / 4, -81 / 2, 0, 243 / 2, -405 / 2, 81, 0, -297 / 4, 495 / 4, -99 / 2, 0, 27 / 2, -45 / 2, 9, 0,
    729 / 4, -1215 / 4, 243 / 2, 0, -1215 / 4, 2025 / 4, -405 / 2, 0, 243 / 2, -405 / 2, 81, 0, 0, 0, 0, 0,
    -729 / 4, 1215 / 4, -243 / 2, 0, 243, -405, 162, 0, -243 / 4, 405 / 4, -81 / 2, 0, 0, 0, 0, 0,
    243 / 4, -405 / 4, 81 / 2, 0, -243 / 4, 405 / 4, -81 / 2, 0, 27 / 2, -45 / 2, 9, 0, 0, 0, 0, 0,
    243 / 4, -81, 81 / 4, 0, -243 / 2, 162, -81 / 2, 0, 297 / 4, -99, 99 / 4, 0, -27 / 2, 18, -9 / 2, 0,
    -729 / 4, 243, -243 / 4, 0, 1215 / 4, -405, 405 / 4, 0, -243 / 2, 162, -81 / 2, 0, 0, 0, 0, 0,
    729 / 4, -243, 243 / 4, 0, -243, 324, -81, 0, 243 / 4, -81, 81 / 4, 0, 0, 0, 0, 0,
    -243 / 4, 81, -81 / 4, 0, 243 / 4, -81, 81 / 4, 0, -27 / 2, 18, -9 / 2, 0, 0, 0, 0, 0,
    -81 / 4, 81 / 4, -9 / 2, 0, 81 / 2, -81 / 2, 9, 0, -99 / 4, 99 / 4, -11 / 2, 0, 9 / 2, -9 / 2, 1, 0,
    243 / 4, -243 / 4, 27 / 2, 0, -405 / 4, 405 / 4, -45 / 2, 0, 81 / 2, -81 / 2, 9, 0, 0, 0, 0, 0,
    -243 / 4, 243 / 4, -27 / 2, 0, 81, -81, 18, 0, -81 / 4, 81 / 4, -9 / 2, 0, 0, 0, 0, 0,
    81 / 4, -81 / 4, 9 / 2, 0, -81 / 4, 81 / 4, -9 / 2, 0, 9 / 2, -9 / 2, 1, 0, 0, 0, 0, 0
]);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Tract = void 0;
var angle_1 = __webpack_require__(5);
var gl_matrix_1 = __webpack_require__(1);
var math_1 = __webpack_require__(2);
var serial_number_1 = __webpack_require__(29);
var gl_matrix_2 = __webpack_require__(1);
var Tract = /** @class */ (function () {
    function Tract(naxis1, // [pixel]
    naxis2, // [pixel]
    crval1, // [rad]
    crval2, // [rad]
    crpix1, // [pixel]
    crpix2, // [pixel]
    cd, // [rad/pixel]
    options) {
        if (options === void 0) { options = {}; }
        this.naxis1 = naxis1;
        this.naxis2 = naxis2;
        this.crval1 = crval1;
        this.crval2 = crval2;
        this.id = serial_number_1.serialNumber();
        this.fov = angle_1.deg2rad(1.8);
        this.tileSize = options.tileSize || 256;
        this.minTileLevel = options.minTileLevel || 0;
        this.maxTileLevel = options.maxTileLevel || 8;
        var m = gl_matrix_1.mat4.create();
        gl_matrix_1.mat4.rotateZ(m, m, crval1);
        gl_matrix_1.mat4.rotateY(m, m, -crval2);
        gl_matrix_1.mat4.mul(m, m, gl_matrix_1.mat4.fromValues(0, 1, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1));
        gl_matrix_1.mat4.mul(m, m, [
            cd[0], cd[2], 0, 0,
            cd[1], cd[3], 0, 0,
            0, 0, 1, 0,
            0, 0, 0, 1,
        ]);
        gl_matrix_1.mat4.translate(m, m, [-crpix1, -crpix2, 0]);
        gl_matrix_1.mat4.translate(m, m, [0.5, 0.5, 0]);
        this.flipV = options.flipV || false;
        if (options.flipV) {
            gl_matrix_1.mat4.translate(m, m, [0, naxis2, 0]);
            gl_matrix_1.mat4.scale(m, m, [1, -1, 1]);
        }
        this.mMatrix = m;
        this.invMMatrix = gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), this.mMatrix);
        this.refPoint = angle_1.EquatorialCoord.fromRad(crval1, crval2).xyz;
        this.pixelScale = Math.sqrt(Math.abs(cd[0] * cd[3] - cd[1] * cd[2]));
        Tract.id2tract.set(this.id, this);
    }
    Tract.prototype.pixel2xyz = function (j, i) {
        var v = gl_matrix_1.vec4.transformMat4(gl_matrix_1.vec4.create(), [j, i, 0, 1], this.mMatrix);
        var r = Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]);
        return [v[0] / r, v[1] / r, v[2] / r];
    };
    Tract.prototype.xyz2pixel = function (xyz) {
        var sep = gl_matrix_2.vec3.angle(xyz, this.refPoint);
        var r = 1 / Math.cos(sep);
        var x = xyz[0], y = xyz[1], z = xyz[2];
        var pixel = gl_matrix_1.vec4.transformMat4(gl_matrix_1.vec4.create(), [r * x, r * y, r * z, 1], this.invMMatrix);
        return [pixel[0], pixel[1]];
    };
    Tract.prototype.pix2jacobian = function (x, y) {
        var xyz = this.pixel2xyz(x, y);
        var t = gl_matrix_2.vec3.angle(xyz, this.refPoint);
        return 1 / Math.pow(Math.cos(t), 3);
    };
    Tract.prototype.ndc2pixel = function (view, cb) {
        var b = gl_matrix_1.mat4.mul(gl_matrix_1.mat4.create(), this.invMMatrix, view.camera.iPv);
        //  A = pvMatrix * mMatrix
        //  (x, y, z, w) = A * (pix_x, pix_y, 0, 1)
        //
        //  p = x / w   : ndx
        //  q = y / w   : ndy
        //  r = z / w   : ndz
        //
        //  B = A**-1
        //  (pix_x, pix_y, 0, 1) = B * (x, y, z, w)
        //  => (pix_x, pix_y, 0, 1) = w * B * (p, q, r, 1) <= eq1
        //
        //  row 3 of eq1 => b31*p * b32*q + b33*r + b34 = 0
        //  => r = - (b31*p + b32*q + b34) / b33
        //  row 4 of eq1 => 1 = w * (b41*p + b42*q + b43*r + b44)
        //  => w = 1 / (b41*p + b42*q + b43*r + b44)
        //
        //      b11(0)  b12(4)  b13(8)  b14(12)
        //  B = b21(1)  b22(5)  b23(9)  b24(13)
        //      b31(2)  b32(6)  b33(10) b34(14)
        //      b41(3)  b42(7)  b43(11) b44(15)
        cb(function (p, q) {
            var r = -(b[2] * p + b[6] * q + b[14]) / b[10];
            var w = 1 / ((b[3] * p) + (b[7] * q) + (b[11] * r) + b[15]);
            var v = gl_matrix_1.vec4.fromValues(p, q, r, 1);
            gl_matrix_1.vec4.transformMat4(v, v, b);
            return [w * v[0], w * v[1], w];
        });
    };
    Tract.prototype.tileIndices = function (view, lodBias) {
        // i: vertical raw pixelo axis
        // j: horizontal raw pixel axis
        // p: vertical tile index
        // q: horizontal tile index
        var minJ = Number.POSITIVE_INFINITY;
        var maxJ = Number.NEGATIVE_INFINITY;
        var minI = Number.POSITIVE_INFINITY;
        var maxI = Number.NEGATIVE_INFINITY;
        this.ndc2pixel(view, function (ndc2bpixel) {
            for (var _i = 0, _a = [[-1, -1], [-1, 1], [1, -1], [1, 1]]; _i < _a.length; _i++) {
                var _b = _a[_i], ndx = _b[0], ndy = _b[1];
                var _c = ndc2bpixel(ndx, ndy), j = _c[0], i = _c[1], w = _c[2];
                if (w < 0) {
                    return Tract.noIndex;
                }
                if (j < minJ) {
                    minJ = j;
                }
                if (j > maxJ) {
                    maxJ = j;
                }
                if (i < minI) {
                    minI = i;
                }
                if (i > maxI) {
                    maxI = i;
                }
            }
        });
        if (maxJ < 0 || this.naxis1 < minJ) {
            return Tract.noIndex;
        }
        if (maxI < 0 || this.naxis2 < minI) {
            return Tract.noIndex;
        }
        minJ = Math.max(minJ, 0);
        maxJ = Math.min(maxJ, this.naxis1);
        minI = Math.max(minI, 0);
        maxI = Math.min(maxI, this.naxis2);
        var density = (view.camera.arc / this.pixelScale) / view.drawingBufferHeight; // (raw pixel) / (display pixel)
        var level = math_1.clamp(Math.log(density) / Math.LN2 + lodBias, this.minTileLevel, this.maxTileLevel);
        var baseLevel = Math.floor(level);
        var lodAlpha = 1 - (level - baseLevel);
        var tileSize = this.tileSize << baseLevel;
        var minP = Math.floor(minI / tileSize);
        var maxP = Math.floor(maxI / tileSize);
        var minQ = Math.floor(minJ / tileSize);
        var maxQ = Math.floor(maxJ / tileSize);
        return { minP: minP, maxP: maxP, minQ: minQ, maxQ: maxQ, baseLevel: baseLevel, lodAlpha: lodAlpha };
    };
    Tract.fromFitsHeader = function (h, options) {
        if (options === void 0) { options = {}; }
        console.assert(h.CTYPE1 === undefined || h.CTYPE1 === 'RA---TAN');
        console.assert(h.CTYPE2 === undefined || h.CTYPE2 === 'DEC--TAN');
        console.assert(h.LONPOLE === undefined);
        console.assert(h.LATPOLE === undefined);
        var tileSize = options.tileSize, minTileLevel = options.minTileLevel, maxTileLevel = options.maxTileLevel, flipV = options.flipV;
        return new Tract(card(h, 'NAXIS1', 'number'), card(h, 'NAXIS2', 'number'), angle_1.deg2rad(card(h, 'CRVAL1', 'number')), angle_1.deg2rad(card(h, 'CRVAL2', 'number')), card(h, 'CRPIX1', 'number'), card(h, 'CRPIX2', 'number'), [
            angle_1.deg2rad(card(h, 'CD1_1', 'number')),
            angle_1.deg2rad(card(h, 'CD1_2', 'number', 0)),
            angle_1.deg2rad(card(h, 'CD2_1', 'number', 0)),
            angle_1.deg2rad(card(h, 'CD2_2', 'number')),
        ], {
            tileSize: tileSize,
            minTileLevel: minTileLevel,
            maxTileLevel: maxTileLevel,
            flipV: flipV,
        });
    };
    Tract.fromId = function (id) {
        return Tract.id2tract.get(id);
    };
    Tract.encodeTileId = function (tract, level, p, q) {
        return tract.id + ":" + level + ":" + p + ":" + q;
    };
    Tract.decodeTileId = function (id) {
        var _a = id.split(':').map(Number), tractId = _a[0], level = _a[1], p = _a[2], q = _a[3];
        var tract = Tract.fromId(tractId);
        return { tract: tract, level: level, p: p, q: q };
    };
    Tract.prototype.encodeTileId = function (level, p, q) {
        return Tract.encodeTileId(this, level, p, q);
    };
    Tract.noIndex = { minP: 0, maxP: -1, minQ: 0, maxQ: -1, baseLevel: -1, lodAlpha: -1 };
    Tract.id2tract = new Map();
    return Tract;
}());
exports.Tract = Tract;
function card(h, key, type, defaultValue) {
    var v = key in h ? h[key] : defaultValue;
    if (typeof v !== type) {
        throw new Error("type mismatch: " + type + " for [" + key + "] = " + v);
    }
    return v;
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = __webpack_require__(63);
Object.defineProperty(exports, "Renderer", { enumerable: true, get: function () { return renderer_1.Renderer; } });
Object.defineProperty(exports, "JOINT", { enumerable: true, get: function () { return renderer_1.JOINT; } });
Object.defineProperty(exports, "Path", { enumerable: true, get: function () { return renderer_1.Path; } });
Object.defineProperty(exports, "Point", { enumerable: true, get: function () { return renderer_1.Point; } });
Object.defineProperty(exports, "BlendMode", { enumerable: true, get: function () { return renderer_1.BlendMode; } });


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PanLayer = void 0;
var tslib_1 = __webpack_require__(0);
var inertial_mouse_1 = __webpack_require__(9);
var gl_matrix_1 = __webpack_require__(1);
var math_1 = __webpack_require__(2);
var mouse_1 = __webpack_require__(19);
var point_event_layer_1 = __webpack_require__(7);
var EPSILON = (1 / 3600) / 180 * Math.PI;
var PanLayer = /** @class */ (function (_super) {
    tslib_1.__extends(PanLayer, _super);
    function PanLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.m = gl_matrix_1.mat2.create();
        _this.dblclick = function (e) {
            var coord = _this.globe.canvas.coordFromClientCoord(e);
            var _a = _this.globe.viewFactory.coord2thetaphi(coord), theta = _a[0], phi = _a[1];
            _this.globe.viewFactory.jumpTo({ theta: theta, phi: phi });
        };
        return _this;
    }
    PanLayer.prototype.onAdd = function () {
        _super.prototype.onAdd.call(this);
        var el = this.globe.canvas.domElement;
        el.addEventListener('dblclick', this.dblclick);
        this.setupDragEvent();
    };
    PanLayer.prototype.onRemove = function () {
        var el = this.globe.canvas.domElement;
        el.removeEventListener('dblclick', this.dblclick);
        this.im.teardown();
    };
    PanLayer.prototype.hit = function (e) {
        var hit = false;
        e.originalEvent({
            mouse: function (me) {
                hit = mouse_1.mouse.button(me) === mouse_1.mouse.Button.LEFT;
            },
            touch: function () {
                hit = true;
            },
        });
        return hit;
    };
    PanLayer.prototype.dragStart = function (e) {
        this.hit(e) && this.im.start(e);
    };
    PanLayer.prototype.dragEnd = function () {
        this.im.unbind();
    };
    PanLayer.prototype.setupDragEvent = function () {
        var _this = this;
        var fovy0;
        this.im = new inertial_mouse_1.InertialMouse({
            down: function (e) {
                var canvas = _this.globe.canvas;
                var _a = _this.offset(e.r), x = _a.x, y = _a.y;
                var vf = _this.globe.viewFactory;
                var c0 = vf.coord2thetaphi(canvas.coordFromOffset(x, y));
                var cx = vf.coord2thetaphi(canvas.coordFromOffset(x + 1, y));
                var cy = vf.coord2thetaphi(canvas.coordFromOffset(x, y + 1));
                if (Math.abs(c0[1] - cx[1]) > Math.PI) {
                    cx[1] += (cx[1] > c0[1] ? -1 : +1) * 2 * Math.PI;
                }
                if (Math.abs(c0[1] - cy[1]) > Math.PI) {
                    cy[1] += (cy[1] > c0[1] ? -1 : +1) * 2 * Math.PI;
                }
                gl_matrix_1.mat2.set(_this.m, cx[1] - c0[1], cx[0] - c0[0], cy[1] - c0[1], cy[0] - c0[0]);
                fovy0 = _this.globe.viewFactory.fovy;
            },
            move: function (e) {
                var _a = e.d, dx = _a.x, dy = _a.y;
                var dCoord = gl_matrix_1.vec2.transformMat2(gl_matrix_1.vec2.create(), [dx, dy], _this.m);
                var vf = _this.globe.viewFactory;
                var scale = Math.min(_this.globe.viewFactory.fovy / fovy0, 1);
                vf.phi -= scale * dCoord[0];
                vf.theta -= scale * dCoord[1];
                vf.theta = math_1.clamp(vf.theta, -Math.PI / 2 + EPSILON, Math.PI / 2 - EPSILON);
            },
            setNextTick: function (tick) {
                if (_this.animation === undefined) {
                    _this.animation = _this.globe.animation(function () { return tick(); }, { cameraMotion: true }).then(function () {
                        _this.animation = undefined;
                    });
                }
            },
            moveend: function () {
                _this.animation.stop();
            },
        });
        this.im.physics.k = 4.e-2;
        this.im.physics.friction = 0.05;
    };
    return PanLayer;
}(point_event_layer_1.PointerEventLayer));
exports.PanLayer = PanLayer;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SinglePointerEvent = exports.isTouchEvent = void 0;
var v2_1 = __webpack_require__(10);
function isTouchEvent(e) {
    return window.TouchEvent && e instanceof TouchEvent;
}
exports.isTouchEvent = isTouchEvent;
var SinglePointerEvent = /** @class */ (function () {
    function SinglePointerEvent(e) {
        this.e = e;
    }
    SinglePointerEvent.prototype.stopPropagation = function () {
        this.e.stopPropagation();
    };
    SinglePointerEvent.prototype.preventDefault = function () {
        this.e.preventDefault();
    };
    Object.defineProperty(SinglePointerEvent.prototype, "clientX", {
        get: function () {
            if (isTouchEvent(this.e)) {
                return (this.e.type === 'touchend' ? this.e.changedTouches : this.e.touches).item(0).clientX;
            }
            else {
                return this.e.clientX;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SinglePointerEvent.prototype, "clientY", {
        get: function () {
            if (isTouchEvent(this.e)) {
                return (this.e.type === 'touchend' ? this.e.changedTouches : this.e.touches).item(0).clientY;
            }
            else {
                return this.e.clientY;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SinglePointerEvent.prototype, "clientCoord", {
        get: function () {
            return new v2_1.V2(this.clientX, this.clientY);
        },
        enumerable: false,
        configurable: true
    });
    SinglePointerEvent.bindDown = function (target, cb, cancel, useCapture) {
        if (useCapture === void 0) { useCapture = false; }
        var mouse = function (e) {
            cb(new SinglePointerEvent(e));
        };
        var touch = function (e) {
            if (e.touches.length === 1) {
                cb(new SinglePointerEvent(e));
            }
            if (e.touches.length > 1) {
                cancel && cancel(new SinglePointerEvent(e));
            }
        };
        target.addEventListener('mousedown', mouse, useCapture);
        target.addEventListener('touchstart', touch, useCapture);
        return function () {
            target.removeEventListener('mousedown', mouse, useCapture);
            target.removeEventListener('touchstart', touch, useCapture);
        };
    };
    SinglePointerEvent.bindMove = function (target, cb, useCapture) {
        if (useCapture === void 0) { useCapture = false; }
        var mouse = function (e) {
            cb(new SinglePointerEvent(e));
        };
        var touch = function (e) {
            if (e.touches.length === 1) {
                cb(new SinglePointerEvent(e));
            }
        };
        target.addEventListener('mousemove', mouse, useCapture);
        target.addEventListener('touchmove', touch, useCapture);
        return function () {
            target.removeEventListener('mousemove', mouse, useCapture);
            target.removeEventListener('touchmove', touch, useCapture);
        };
    };
    SinglePointerEvent.bindUp = function (target, cb, useCapture) {
        if (useCapture === void 0) { useCapture = false; }
        var mouse = function (e) {
            cb(new SinglePointerEvent(e));
        };
        var touch = function (e) {
            if (e.touches.length === 0) {
                cb(new SinglePointerEvent(e));
            }
        };
        target.addEventListener('mouseup', mouse, useCapture);
        target.addEventListener('touchend', touch, useCapture);
        return function () {
            target.removeEventListener('mouseup', mouse, useCapture);
            target.removeEventListener('touchend', touch, useCapture);
        };
    };
    SinglePointerEvent.prototype.originalEvent = function (_a) {
        var mouse = _a.mouse, touch = _a.touch;
        if (isTouchEvent(this.e)) {
            touch && touch(this.e);
        }
        else {
            mouse && mouse(this.e);
        }
    };
    return SinglePointerEvent;
}());
exports.SinglePointerEvent = SinglePointerEvent;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Physics = void 0;
var v2_1 = __webpack_require__(10);
var Physics = /** @class */ (function () {
    function Physics() {
        this.k = 2.0e-2;
        this.friction = 0.2;
        this.slick = true;
        this.minV = 0.5;
        this.bound = false;
        this.moving = false;
    }
    Physics.prototype.put = function (r) {
        this.r = this.anchor = r;
        this.v = new v2_1.V2(0, 0);
    };
    Physics.prototype.hook = function (anchor) {
        this.bound = true;
        this.anchor = anchor;
    };
    Physics.prototype.unhook = function () {
        this.bound = false;
    };
    Physics.prototype.stop = function () {
        this.anchor = this.r;
        this.v = new v2_1.V2(0, 0);
        this.moving = false;
    };
    Physics.prototype.tick = function (t) {
        var k = this.k;
        var moving0 = this.moving;
        var r0 = this.r.clone();
        if (!moving0) {
            this.t = t;
        }
        var T = k * (t - this.t);
        var maxDT = 0.5;
        while (T > 0) {
            var dt = Math.min(maxDT, T);
            var delta = new v2_1.V2(this.anchor.x - this.r.x, this.anchor.y - this.r.y);
            var a = this.bound || !this.slick ? new v2_1.V2(// acceleration of critical damping
            delta.x - 2 * this.v.x, delta.y - 2 * this.v.y) : new v2_1.V2(// friction
            -this.friction * this.v.x, -this.friction * this.v.y);
            this.v.x += dt * a.x;
            this.v.y += dt * a.y;
            var dx = dt * this.v.x;
            var dy = dt * this.v.y;
            this.r.x += dx;
            this.r.y += dy;
            T -= maxDT;
        }
        var dr = new v2_1.V2(this.r.x - r0.x, this.r.y - r0.y);
        this.t = t;
        this.moving = this.willMove();
        return {
            r: this.r,
            dr: dr,
            movestart: !moving0,
            moveend: !this.moving,
        };
    };
    Physics.prototype.willMove = function () {
        var minV = this.minV = 1;
        if (this.bound || !this.slick) {
            return Math.abs(this.anchor.x - this.r.x) > minV || Math.abs(this.anchor.y - this.r.y) > minV;
        }
        else {
            var v = this.v;
            var f = this.friction;
            return Math.abs(v.x / f) >= minV || Math.abs(v.y / f) >= minV;
        }
    };
    return Physics;
}());
exports.Physics = Physics;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.mouse = exports.Button = void 0;
var Button;
(function (Button) {
    Button[Button["LEFT"] = 0] = "LEFT";
    Button[Button["RIGHT"] = 1] = "RIGHT";
    Button[Button["MIDDLE"] = 2] = "MIDDLE";
})(Button = exports.Button || (exports.Button = {}));
function button(e) {
    switch (e.button) {
        case 2:
            return Button.RIGHT;
        case 1:
            return Button.MIDDLE;
        default: {
            if (!e.altKey && e.ctrlKey && !e.shiftKey) {
                return Button.RIGHT;
            }
            if (e.altKey && !e.ctrlKey && !e.shiftKey) {
                return Button.MIDDLE;
            }
        }
    }
    return Button.LEFT;
}
exports.mouse = {
    button: button,
    Button: Button,
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomLayer = void 0;
var tslib_1 = __webpack_require__(0);
var inertial_wheel_1 = __webpack_require__(39);
var __1 = __webpack_require__(8);
var math_1 = __webpack_require__(2);
var layer_1 = __webpack_require__(4);
var ZoomLayer = /** @class */ (function (_super) {
    tslib_1.__extends(ZoomLayer, _super);
    function ZoomLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.k = 7.5e-2;
        _this.pointerDown = function () {
            _this.animation && _this.animation.stop();
        };
        return _this;
    }
    ZoomLayer.prototype.onAdd = function () {
        var _this = this;
        this.globe.ee.on('pointer-down', this.pointerDown);
        this.iw = new inertial_wheel_1.InertialWheel(this.globe.canvas.domElement, {
            wheel: function (e) {
                var canvas = _this.globe.canvas;
                var vf = _this.globe.viewFactory;
                var dScale = Math.exp(_this.k * e.v);
                var pole = vf.thetaphi2xyz(Math.PI / 2, 0);
                var centerXyz = vf.thetaphi2xyz(vf.theta, vf.phi);
                var targetXyz = canvas.xyzFromClientCoord(e.originalEvent);
                var x1 = centerXyz[0], y1 = centerXyz[1], z1 = centerXyz[2];
                var x2 = targetXyz[0], y2 = targetXyz[1], z2 = targetXyz[2];
                var dx = (1 - dScale) * (x2 - x1);
                var dy = (1 - dScale) * (y2 - y1);
                var dz = (1 - dScale) * (z2 - z1);
                var dp = math_1.dot(pole, centerXyz); // cos(<(center, pole))
                var cp = Math.sqrt(1 - dp * dp); // sin(<(center, pole))
                if (cp < vf.fovy) {
                    var r = math_1.clamp(cp / vf.fovy - 0.1, 0, 1);
                    dx = r * dx + (1 - r) * x1;
                    dy = r * dy + (1 - r) * y1;
                    dz = r * dz + (1 - r) * z1;
                }
                x1 += dx;
                y1 += dy;
                z1 += dz;
                var coord = __1.EquatorialCoord.fromXyz([x1, y1, z1]);
                var _a = vf.coord2thetaphi(coord), theta = _a[0], phi = _a[1];
                vf.theta = theta;
                vf.phi = phi;
                vf.fovy *= dScale;
                vf.cage();
            },
            wheelend: function () {
                _this.animation.stop();
            },
            setNextTick: function (tick) {
                if (_this.animation === undefined) {
                    _this.animation = _this.globe.animation(function () { return tick(); }, { cameraMotion: true }).then(function () {
                        _this.iw.stop();
                        _this.animation = undefined;
                    });
                }
            },
        });
        this.iw.physics.t1 = 150;
        this.iw.physics.t2 = 150;
    };
    ZoomLayer.prototype.onRemove = function () {
        this.iw.teardown();
        this.globe.ee.off('pointer-down', this.pointerDown);
    };
    return ZoomLayer;
}(layer_1.Layer));
exports.ZoomLayer = ZoomLayer;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Physics = void 0;
var defaults = {
    accDuration: 100,
    t1: 100,
    t2: 200,
};
var Physics = /** @class */ (function () {
    function Physics() {
        this.v = 0;
        this.moving = false;
        this.accDuration = defaults.accDuration;
        this.t1 = defaults.t1;
        this.t2 = defaults.t2;
        this.maxDT = 3 * 1000 / 60;
    }
    Physics.prototype.stop = function () {
        this.a = 0;
        this.v = 0;
        this.moving = false;
    };
    Physics.prototype.kick = function (a, t) {
        this.a = a;
        this.lastAcc = t;
    };
    Physics.prototype.tick = function (t) {
        var moving0 = this.moving;
        if (!moving0) {
            this.t = t;
        }
        if (t - this.lastAcc > this.accDuration) {
            this.a = 0;
        }
        var dt0 = t - this.t;
        var DT = dt0;
        while (DT > 0) {
            var dt = Math.min(DT, this.maxDT);
            DT -= this.maxDT;
            this.v += dt * (this.a === 0 ?
                -1. / this.t2 * this.v :
                this.a / this.t1);
            this.v = clamp(this.v, -1, 1);
        }
        this.t = t;
        this.moving = this.willMove();
        return {
            v: this.v,
            dt: Math.min(1000, dt0),
            wheelstart: !moving0,
            wheelend: !this.moving,
        };
    };
    Physics.prototype.willMove = function () {
        return this.t - this.lastAcc <= this.accDuration || Math.abs(this.v) >= 0.005;
    };
    Physics.defaults = defaults;
    return Physics;
}());
exports.Physics = Physics;
function clamp(x, min, max) {
    return x < min ? min : (x > max ? max : x);
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Animation = exports.AnimationManager = void 0;
var AnimationManager = /** @class */ (function () {
    function AnimationManager(ee, draw) {
        this.ee = ee;
        this.draw = draw;
        this.animations = [];
    }
    AnimationManager.prototype.add = function (cb, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var a = new Animation(cb, options);
        if (a.cameraMotion && this.animations.filter(function (aa) { return aa.cameraMotion; }).length === 0) {
            this.ee.emit('camera-move-start');
        }
        this.animations.push(a);
        a.finally(function () {
            _this.animations.splice(_this.animations.indexOf(a), 1);
            if (a.cameraMotion && _this.animations.filter(function (aa) { return aa.cameraMotion; }).length === 0) {
                _this.ee.emit('camera-move-end');
            }
        });
        this.tick();
        return a;
    };
    AnimationManager.prototype.tick = function () {
        var _this = this;
        if (this.animations.length > 0 && this.rafId === undefined) {
            this.rafId = requestAnimationFrame(function () {
                _this.rafId = undefined;
                var now = performance.now();
                var motionAnimation = 0;
                for (var _i = 0, _a = _this.animations.slice(); _i < _a.length; _i++) {
                    var a = _a[_i];
                    if (a.cameraMotion) {
                        ++motionAnimation;
                    }
                    a.update(now);
                }
                _this.draw();
                _this.tick();
                if (motionAnimation > 0) {
                    _this.ee.emit('camera-move');
                }
            });
        }
    };
    AnimationManager.prototype.stopCameraMotion = function () {
        for (var _i = 0, _a = this.animations.slice(); _i < _a.length; _i++) {
            var a = _a[_i];
            if (a.cameraMotion) {
                a.stop();
            }
        }
    };
    AnimationManager.prototype.clear = function () {
        while (this.animations.length > 0) {
            this.animations[0].stop();
        }
    };
    return AnimationManager;
}());
exports.AnimationManager = AnimationManager;
// TODO cleanup
var Animation = /** @class */ (function () {
    function Animation(cb, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        this.cb = cb;
        this.options = options;
        this.start = performance.now();
        this.last = this.start;
        this.onStop = [];
        this.onFinally = [];
        this.alreadyDone = false;
        this.cameraMotion = !!options.cameraMotion;
        if (this.options.immediate) {
            this.update(performance.now());
        }
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    Animation.prototype.update = function (now) {
        var t = now - this.start;
        var dt = now - this.last;
        this.last = now;
        if (this.options.duration === undefined) {
            this.cb({ t: t, dt: dt, r: NaN });
        }
        else {
            var r = t / this.options.duration;
            this.cb({ t: t, dt: dt, r: Math.min(1, r) });
            if (t > this.options.duration) {
                this.stop();
            }
        }
    };
    Animation.prototype.stop = function () {
        if (this.alreadyDone) {
            console.warn("animation stopped 2 or more times");
        }
        else {
            for (var _i = 0, _a = this.onStop; _i < _a.length; _i++) {
                var f = _a[_i];
                f();
            }
            for (var _b = 0, _c = this.onFinally; _b < _c.length; _b++) {
                var f = _c[_b];
                f();
            }
            this.resolve();
            this.alreadyDone = true;
        }
    };
    Animation.prototype.abort = function () {
        if (this.alreadyDone) {
            console.warn("animation aborted 2 or more times");
        }
        else {
            for (var _i = 0, _a = this.onFinally; _i < _a.length; _i++) {
                var f = _a[_i];
                f();
            }
            this.reject();
            this.alreadyDone = true;
        }
    };
    Animation.prototype.finally = function (f) {
        this.onFinally.push(f);
        return this;
    };
    Animation.prototype.then = function (f) {
        this.onStop.push(f);
        return this;
    };
    return Animation;
}());
exports.Animation = Animation;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.View = void 0;
var View = /** @class */ (function () {
    function View(camera, lodBias, retina, drawingBufferHeight) {
        this.camera = camera;
        this.lodBias = lodBias;
        this.retina = retina;
        this.drawingBufferHeight = drawingBufferHeight;
    }
    return View;
}());
exports.View = View;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RollLayer = void 0;
var tslib_1 = __webpack_require__(0);
var inertial_mouse_1 = __webpack_require__(9);
var mouse_1 = __webpack_require__(19);
var point_event_layer_1 = __webpack_require__(7);
var RollLayer = /** @class */ (function (_super) {
    tslib_1.__extends(RollLayer, _super);
    function RollLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RollLayer.prototype.onAdd = function () {
        this.setupDragEvent();
    };
    RollLayer.prototype.onRemove = function () {
        this.im.teardown();
    };
    RollLayer.prototype.hit = function (e) {
        var hit = false;
        e.originalEvent({
            mouse: function (me) {
                hit = mouse_1.mouse.button(me) === mouse_1.mouse.Button.MIDDLE;
            },
        });
        return hit;
    };
    RollLayer.prototype.dragStart = function (e) {
        this.im.start(e);
    };
    RollLayer.prototype.setupDragEvent = function () {
        var _this = this;
        this.im = new inertial_mouse_1.InertialMouse({
            move: function (e) {
                var _a = _this.offset(e.r), x = _a.x, y = _a.y;
                var _b = e.d, dx = _b.x, dy = _b.y;
                var canvas = _this.globe.canvas;
                x -= canvas.domElement.clientWidth / 2;
                y -= canvas.domElement.clientHeight / 2;
                if (x !== 0 && y !== 0) {
                    _this.globe.viewFactory.roll += (y * dx - x * dy) / (x * x + y * y);
                }
            },
            moveend: function () {
                _this.animation.stop();
            },
            setNextTick: function (tick) {
                if (_this.animation === undefined) {
                    _this.animation = _this.globe.animation(function () { return tick(); }, { cameraMotion: true }).then(function () {
                        _this.animation = undefined;
                    });
                }
            },
        });
    };
    return RollLayer;
}(point_event_layer_1.PointerEventLayer));
exports.RollLayer = RollLayer;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchLayer = void 0;
var tslib_1 = __webpack_require__(0);
var layer_1 = __webpack_require__(4);
var hammerjs_1 = tslib_1.__importDefault(__webpack_require__(47));
var math_1 = __webpack_require__(2);
var angle_1 = __webpack_require__(5);
var TouchLayer = /** @class */ (function (_super) {
    tslib_1.__extends(TouchLayer, _super);
    function TouchLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TouchLayer.prototype.onAdd = function () {
        this.mc = new hammerjs_1.default(this.canvas);
        this.handlePinch();
        this.handleDoubleTap();
        this.handleTap2();
    };
    TouchLayer.prototype.onRemove = function () {
        this.mc.destroy();
    };
    Object.defineProperty(TouchLayer.prototype, "canvas", {
        get: function () {
            return this.globe.canvas.domElement;
        },
        enumerable: false,
        configurable: true
    });
    TouchLayer.prototype.handleDoubleTap = function () {
        var _this = this;
        this.mc.get('doubletap').set({ posThreshold: 30 });
        this.mc.on('doubletap', function (e) {
            if (e.pointerType === 'touch') {
                var _a = e.center, clientX = _a.x, clientY = _a.y;
                var _b = zoomOnClientCoord(_this.globe, 0.5, { clientX: clientX, clientY: clientY }), theta = _b.theta, phi = _b.phi, fovy = _b.fovy;
                _this.globe.viewFactory.jumpTo({ theta: theta, phi: phi, fovy: fovy });
                _this.globe.requestRefresh();
            }
        });
    };
    TouchLayer.prototype.handleTap2 = function () {
        var _this = this;
        this.mc.add(new hammerjs_1.default.Tap({ event: 'tap2', pointers: 2 }));
        this.mc.on('tap2', function (e) {
            var vf = _this.globe.viewFactory;
            vf.jumpTo({ fovy: vf.fovy * 2 });
        });
    };
    TouchLayer.prototype.handlePinch = function () {
        var _this = this;
        this.mc.get('pinch').set({ enable: true });
        var scale;
        this.mc.on('pinchstart', function (e) {
            scale = 1;
        });
        this.mc.on('pinchmove', function (e) {
            var _a = e.center, clientX = _a.x, clientY = _a.y;
            var _b = zoomOnClientCoord(_this.globe, scale / e.scale, { clientX: clientX, clientY: clientY }), theta = _b.theta, phi = _b.phi, fovy = _b.fovy;
            var vf = _this.globe.viewFactory;
            scale = e.scale;
            vf.theta = theta;
            vf.phi = phi;
            vf.fovy = fovy;
            vf.cage();
            _this.globe.requestRefresh();
        });
    };
    return TouchLayer;
}(layer_1.Layer));
exports.TouchLayer = TouchLayer;
function zoomOnClientCoord(globe, dScale, clinentCoord) {
    var canvas = globe.canvas;
    var vf = globe.viewFactory;
    var pole = vf.thetaphi2xyz(Math.PI / 2, 0);
    var centerXyz = vf.thetaphi2xyz(vf.theta, vf.phi);
    var targetXyz = canvas.xyzFromClientCoord(clinentCoord);
    var x1 = centerXyz[0], y1 = centerXyz[1], z1 = centerXyz[2];
    var x2 = targetXyz[0], y2 = targetXyz[1], z2 = targetXyz[2];
    var dx = (1 - dScale) * (x2 - x1);
    var dy = (1 - dScale) * (y2 - y1);
    var dz = (1 - dScale) * (z2 - z1);
    var dp = math_1.dot(pole, centerXyz); // cos(<(center, pole))
    var cp = Math.sqrt(1 - dp * dp); // sin(<(center, pole))
    if (cp < vf.fovy) {
        var r = math_1.clamp(cp / vf.fovy - 0.1, 0, 1);
        dx = r * dx + (1 - r) * x1;
        dy = r * dy + (1 - r) * y1;
        dz = r * dz + (1 - r) * z1;
    }
    x1 += dx;
    y1 += dy;
    z1 += dz;
    var coord = angle_1.EquatorialCoord.fromXyz([x1, y1, z1]);
    var _a = vf.coord2thetaphi(coord), theta = _a[0], phi = _a[1];
    return {
        theta: theta,
        phi: phi,
        fovy: vf.fovy * dScale,
    };
}


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = __webpack_require__(48);
Object.defineProperty(exports, "Renderer", { enumerable: true, get: function () { return renderer_1.Renderer; } });
var coord_frame_1 = __webpack_require__(54);
Object.defineProperty(exports, "CoordFrame", { enumerable: true, get: function () { return coord_frame_1.CoordFrame; } });
var texture_provider_1 = __webpack_require__(55);
Object.defineProperty(exports, "TextureProvider", { enumerable: true, get: function () { return texture_provider_1.TextureProvider; } });
Object.defineProperty(exports, "AsyncTextureProvider", { enumerable: true, get: function () { return texture_provider_1.AsyncTextureProvider; } });
// SimpleFitsTextureProvider,
Object.defineProperty(exports, "SimpleImageTextureProvider", { enumerable: true, get: function () { return texture_provider_1.SimpleImageTextureProvider; } });
Object.defineProperty(exports, "TextureRef", { enumerable: true, get: function () { return texture_provider_1.TextureRef; } });
Object.defineProperty(exports, "TileTexture", { enumerable: true, get: function () { return texture_provider_1.TileTexture; } });


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = require("@hscmap/healpix");

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = require("axios");

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.serialNumber = void 0;
var i = 0;
function serialNumber() {
    return ++i;
}
exports.serialNumber = serialNumber;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BillboardRenderer = void 0;
var gl_wrapper_1 = __webpack_require__(3);
var pack_rects_1 = __webpack_require__(66);
var canvas_1 = __webpack_require__(31);
var BillboardRenderer = /** @class */ (function () {
    function BillboardRenderer(gl, images, imageRefs) {
        if (images === void 0) { images = []; }
        if (imageRefs === void 0) { imageRefs = []; }
        this.gl = gl;
        this.scale = 1;
        this.alpha = 1;
        this.color = [1, 1, 1, 1];
        this.program = gl_wrapper_1.Program.new(gl, __webpack_require__(67).default, __webpack_require__(68).default);
        this.attribList = new gl_wrapper_1.AttribList(gl, {
            members: [
                { name: 'a_vCoord', nComponents: 3 },
                { name: 'a_size', nComponents: 2 },
                { name: 'a_tCoord', nComponents: 2 },
            ],
        });
        this.texture = new gl_wrapper_1.Texture(gl);
        this.buildArray(images, imageRefs);
    }
    BillboardRenderer.prototype.release = function () {
        this.program.release();
        this.attribList.release();
        this.texture.release();
    };
    BillboardRenderer.prototype.buildArray = function (images, imageRefs) {
        var _this = this;
        var gl = this.gl;
        var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        this.packedTexture = packTextures(images, maxTextureSize);
        this.texture.bind(function () {
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, _this.packedTexture.imageData);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
            gl.generateMipmap(gl.TEXTURE_2D);
        });
        var attrs = [];
        var _a = this.packedTexture.imageData, W = _a.width, H = _a.height;
        for (var _i = 0, imageRefs_1 = imageRefs; _i < imageRefs_1.length; _i++) {
            var s = imageRefs_1[_i];
            var _b = s.position, x = _b[0], y = _b[1], z = _b[2];
            var _c = this.packedTexture.bbox[s.imageID], _d = _c.rect, l = _d.left, r = _d.right, t = _d.top, b = _d.bottom, w = _d.width, h = _d.height, o = _c.origin;
            attrs.push(x, y, z, (-1 + o[0]) * w, (-1 + o[1]) * h, l / W, b / H, x, y, z, (+1 + o[0]) * w, (-1 + o[1]) * h, r / W, b / H, x, y, z, (+1 + o[0]) * w, (+1 + o[1]) * h, r / W, t / H, x, y, z, (-1 + o[0]) * w, (-1 + o[1]) * h, l / W, b / H, x, y, z, (+1 + o[0]) * w, (+1 + o[1]) * h, r / W, t / H, x, y, z, (-1 + o[0]) * w, (+1 + o[1]) * h, l / W, t / H);
        }
        this.attribList.setData({
            array: new Float32Array(attrs),
        });
    };
    BillboardRenderer.prototype.render = function (view) {
        var _this = this;
        var alpha = this.alpha;
        if (this.attribList.vertexCount === 0 || alpha <= 0) {
            return;
        }
        var gl = this.gl;
        var p = this.program;
        p.use();
        var ratio = this.scale * (view.retina ? devicePixelRatio : 1);
        p.uniformMatrix4fv({ u_pvMatrix: view.camera.pv });
        p.uniform4fv({ u_color: this.color });
        p.uniform1i({ u_texture: 0 });
        p.uniform1f({
            u_alpha: alpha,
            u_width: 1 / ratio * gl.drawingBufferWidth,
            u_height: 1 / ratio * gl.drawingBufferHeight,
        });
        gl_wrapper_1.utils.enable(gl, [gl.BLEND], function () {
            gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
            _this.texture.bind(function () {
                _this.attribList.enable(p, function () {
                    gl.drawArrays(gl.TRIANGLES, 0, _this.attribList.vertexCount);
                });
            });
        });
    };
    return BillboardRenderer;
}());
exports.BillboardRenderer = BillboardRenderer;
function packTextures(images, maxTextureSize) {
    var rects = images.map(function (image) { return new pack_rects_1.Rect(image.imageData.width + 2, image.imageData.height + 2); });
    try {
        pack_rects_1.packRectsOptimally(rects, maxTextureSize);
    }
    catch (e) {
        console.warn(e);
        return {
            imageData: new ImageData(1, 1),
            bbox: [],
        };
    }
    var width = pack_rects_1.powerOf2(Math.max.apply(Math, rects.map(function (r) { return r.right; })));
    var height = pack_rects_1.powerOf2(Math.max.apply(Math, rects.map(function (r) { return r.bottom; })));
    return canvas_1.get2dContext(width, height, function (ctx) {
        var bbox = [];
        for (var i = 0; i < images.length; ++i) {
            var image = images[i];
            var rect = rects[i];
            ctx.putImageData(image.imageData, rect.left + 1, rect.top + 1);
            bbox.push({ rect: rect, origin: image.origin });
        }
        // window.open(ctx.canvas.toDataURL()) // for debug
        return {
            imageData: ctx.getImageData(0, 0, width, height),
            bbox: bbox,
        };
    });
}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.get2dContext = void 0;
function get2dContext(width, height, cb) {
    var _a = getCanvas(), canvas = _a.canvas, ctx = _a.ctx;
    canvas.width = width;
    canvas.height = height;
    ctx.save();
    ctx.clearRect(0, 0, width, height);
    var retval = cb(ctx);
    ctx.restore();
    return retval;
}
exports.get2dContext = get2dContext;
var getCanvas = (function () {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    return function () { return ({ canvas: canvas, ctx: ctx }); };
})();


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.text2imageData = void 0;
var canvas_1 = __webpack_require__(31);
var dom_1 = __webpack_require__(70);
function text2imageData(text, font, color, margin) {
    if (font === void 0) { font = '48pt sans-serif'; }
    if (color === void 0) { color = 'rgba(255, 255, 255, 1)'; }
    if (margin === void 0) { margin = 10; }
    var _a = dom_1.elementSize(function (el) {
        el.style.font = font;
        el.innerText = text;
    }), width = _a.width, height = _a.height;
    width += 2 * margin;
    height += 2 * margin;
    return canvas_1.get2dContext(width, height, function (ctx) {
        ctx.font = font;
        ctx.textBaseline = 'top';
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        for (var _i = 0, _a = [[0.25, 15], [0.5, 10], [0.75, 5]]; _i < _a.length; _i++) {
            var _b = _a[_i], o = _b[0], w = _b[1];
            ctx.strokeStyle = "rgba(0, 0, 0, " + o + ")";
            ctx.lineWidth = w;
            ctx.strokeText(text, margin, margin);
        }
        ctx.fillStyle = color;
        ctx.fillText(text, margin, margin);
        return ctx.getImageData(0, 0, width, height);
    });
}
exports.text2imageData = text2imageData;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "5524030224b6d804143652d9a6ed09a7._json";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(35);
module.exports = __webpack_require__(8);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(36);


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = require("es6-promise/auto");

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Globe = void 0;
var tslib_1 = __webpack_require__(0);
var pan_layer_1 = __webpack_require__(16);
var zoom_layer_1 = __webpack_require__(20);
var animation = tslib_1.__importStar(__webpack_require__(22));
var canvas_1 = __webpack_require__(42);
var view_factory_1 = __webpack_require__(43);
var roll_layer_1 = __webpack_require__(24);
var wolfy87_eventemitter_1 = tslib_1.__importDefault(__webpack_require__(46));
var point_event_layer_1 = __webpack_require__(7);
var touch_layer_1 = __webpack_require__(25);
var Globe = /** @class */ (function () {
    function Globe(el, defaultLayers, preserveBuffer) {
        var _this = this;
        if (defaultLayers === void 0) { defaultLayers = true; }
        if (preserveBuffer === void 0) { preserveBuffer = false; }
        this.ee = new wolfy87_eventemitter_1.default();
        this.viewFactory = new view_factory_1.ViewFactory(this);
        this.layers = [];
        this.rafId = undefined;
        this.animationManager = new animation.AnimationManager(this.ee, function () { return _this.draw(); });
        var canvas = this.canvas = new canvas_1.Canvas(this, preserveBuffer);
        this.canvas = canvas;
        el && this.mount(el);
        this.gl = canvas.gl;
        this.viewFactory.aspectRatio = this.canvas.aspectRatio;
        point_event_layer_1.PointerEventLayer.initGlobe(this);
        defaultLayers && this.initDefaultLayers();
        this.resize();
        this.requestRefresh();
    }
    Globe.prototype.mount = function (el) {
        this.el = el;
        el.appendChild(this.canvas.domElement);
    };
    Globe.prototype.unmount = function () {
        console.assert(this.el !== undefined);
        this.el.removeChild(this.canvas.domElement);
        this.el = undefined;
    };
    Globe.prototype.release = function () {
        this.animationManager.clear();
        while (this.layers.length > 0) {
            this.removeLayer(this.layers[0]);
        }
        if (this.el) {
            this.unmount();
        }
        this.canvas.release();
    };
    Globe.prototype.resize = function () {
        this.canvas.resize(this.viewFactory.retina);
        this.viewFactory.aspectRatio = this.canvas.aspectRatio;
        this.requestRefresh();
    };
    Globe.prototype.setSize = function (w, h) {
        this.canvas.setSize(w, h);
        this.viewFactory.aspectRatio = this.canvas.aspectRatio;
        this.requestRefresh();
    };
    Globe.prototype.addLayer = function (layer) {
        layer.changeGlobe(this);
        this.layers.push(layer);
        this.sortLayers();
        this.requestRefresh();
        this.ee.emit('layer-change');
    };
    Globe.prototype.removeLayer = function (layer) {
        var i = this.layers.indexOf(layer);
        if (i >= 0) {
            this.layers.splice(i, 1);
            layer.changeGlobe(undefined);
        }
        this.requestRefresh();
        this.ee.emit('layer-change');
    };
    Globe.prototype.requestRefresh = function () {
        var _this = this;
        if (this.rafId === undefined) {
            this.rafId = requestAnimationFrame(function () {
                _this.rafId = undefined;
                _this.draw();
            });
        }
    };
    Globe.prototype.animation = function (cb, options) {
        return this.animationManager.add(cb, options);
    };
    Globe.prototype.stopCameraMotion = function () {
        this.animationManager.stopCameraMotion();
    };
    Globe.prototype.setLayerSortFunc = function (f) {
        this.layerSortFunc = f;
        this.sortLayers();
    };
    Globe.prototype.eachLayer = function (cb) {
        for (var _i = 0, _a = this.layers; _i < _a.length; _i++) {
            var l = _a[_i];
            cb(l);
        }
    };
    Globe.prototype.draw = function () {
        this.ee.emit('draw');
        var view = this.viewFactory.view();
        var gl = this.gl;
        gl.clearColor(0, 0, 0, 0);
        // gl.clearColor(0, 0, 0, 1.e-16) // on Safari, gl.clear does not work sanely if alpha = 0
        gl.clear(gl.COLOR_BUFFER_BIT);
        for (var _i = 0, _a = this.layers; _i < _a.length; _i++) {
            var layer = _a[_i];
            layer.render(view);
        }
    };
    Globe.prototype.initDefaultLayers = function () {
        this.addLayer(new pan_layer_1.PanLayer());
        this.addLayer(new roll_layer_1.RollLayer());
        this.addLayer(new zoom_layer_1.ZoomLayer());
        this.addLayer(new touch_layer_1.TouchLayer());
    };
    Globe.prototype.sortLayers = function () {
        if (this.layerSortFunc) {
            this.layers.sort(this.layerSortFunc);
        }
    };
    return Globe;
}());
exports.Globe = Globe;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveEndEvent = exports.MoveStartEvent = exports.MoveEvent = exports.UpEvent = exports.DownEvent = exports.InertialMouse = void 0;
var SinglePointerEvent_1 = __webpack_require__(17);
var physics_1 = __webpack_require__(18);
var InertialMouse = /** @class */ (function () {
    function InertialMouse(cb) {
        var _this = this;
        this.cb = cb;
        this.physics = new physics_1.Physics();
        this.dead = false;
        this.events = [];
        this.pointmove = function (e) {
            if (_this.dead) {
                return;
            }
            _this.physics.hook(e.clientCoord);
            _this.cb.setNextTick(function () { return _this.tick(); });
        };
        this.pointend = function (e) {
            if (_this.dead) {
                return;
            }
            _this.physics.unhook();
            _this.unbind();
            _this.cb.up && _this.cb.up(new UpEvent(e.clientCoord, e));
        };
        cb.setNextTick = cb.setNextTick || defaultSetNextTick();
    }
    InertialMouse.prototype.teardown = function () {
        this.dead = true;
        this.unbind();
    };
    InertialMouse.prototype.stop = function () {
        this.physics.stop();
    };
    InertialMouse.prototype.unbind = function () {
        while (this.events.length > 0) {
            this.events.pop()();
        }
    };
    InertialMouse.prototype.start = function (e) {
        var r = e.clientCoord;
        this.physics.put(r);
        this.events.push(SinglePointerEvent_1.SinglePointerEvent.bindMove(document, this.pointmove));
        this.events.push(SinglePointerEvent_1.SinglePointerEvent.bindUp(document, this.pointend));
        this.cb.down && this.cb.down(new DownEvent(r, e));
    };
    InertialMouse.prototype.tick = function () {
        var _this = this;
        if (this.dead) {
            return;
        }
        var _a = this.physics.tick(performance.now()), r = _a.r, dr = _a.dr, movestart = _a.movestart, moveend = _a.moveend;
        movestart && this.cb.movestart && this.cb.movestart(new MoveStartEvent());
        this.cb.move && this.cb.move(new MoveEvent(r, dr));
        moveend && this.cb.moveend && this.cb.moveend(new MoveEndEvent());
        moveend || this.cb.setNextTick(function () { return _this.tick(); });
    };
    return InertialMouse;
}());
exports.InertialMouse = InertialMouse;
function defaultSetNextTick() {
    var rafId;
    return function (tick) {
        if (rafId === undefined) {
            rafId = requestAnimationFrame(function () {
                rafId = undefined;
                tick();
            });
        }
    };
}
var DownEvent = /** @class */ (function () {
    function DownEvent(r, pointerEvent) {
        this.r = r;
        this.pointerEvent = pointerEvent;
    }
    return DownEvent;
}());
exports.DownEvent = DownEvent;
var UpEvent = /** @class */ (function () {
    function UpEvent(r, pointerEvent) {
        this.r = r;
        this.pointerEvent = pointerEvent;
    }
    return UpEvent;
}());
exports.UpEvent = UpEvent;
var MoveEvent = /** @class */ (function () {
    function MoveEvent(r, d) {
        this.r = r;
        this.d = d;
    }
    return MoveEvent;
}());
exports.MoveEvent = MoveEvent;
var MoveStartEvent = /** @class */ (function () {
    function MoveStartEvent() {
    }
    return MoveStartEvent;
}());
exports.MoveStartEvent = MoveStartEvent;
var MoveEndEvent = /** @class */ (function () {
    function MoveEndEvent() {
    }
    return MoveEndEvent;
}());
exports.MoveEndEvent = MoveEndEvent;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inertial_wheel_1 = __webpack_require__(40);
Object.defineProperty(exports, "InertialWheel", { enumerable: true, get: function () { return inertial_wheel_1.InertialWheel; } });
var physics_1 = __webpack_require__(21);
Object.defineProperty(exports, "Physics", { enumerable: true, get: function () { return physics_1.Physics; } });


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.InertialWheelEndEvent = exports.InertialWheelStartEvent = exports.InertialWheelEvent = exports.InertialWheel = void 0;
var magic_trackpad_detector_1 = __webpack_require__(41);
var physics_1 = __webpack_require__(21);
var InertialWheel = /** @class */ (function () {
    function InertialWheel(target, cb) {
        var _this = this;
        this.target = target;
        this.cb = cb;
        this.physics = new physics_1.Physics();
        this.magicTrackpadDetector = new magic_trackpad_detector_1.MagicTrackpadDetector();
        this.wheel = function (e) {
            e.preventDefault();
            if (!_this.magicTrackpadDetector.inertial(e)) {
                _this.lastNativeEvent = e;
                var a = e.deltaY > 0 ? 1 : (e.deltaY < 0 ? -1 : 0);
                _this.physics.kick(a, performance.now());
            }
            _this.cb.setNextTick(function () { return _this.tick(); });
        };
        this.normalize = 60 / 1000;
        if (cb.setNextTick === undefined) {
            cb.setNextTick = defaultSetNextTick();
        }
        target.addEventListener('wheel', this.wheel);
    }
    InertialWheel.prototype.teardown = function () {
        this.target.removeEventListener('wheel', this.wheel);
    };
    InertialWheel.prototype.stop = function () {
        this.physics.stop();
    };
    InertialWheel.prototype.tick = function () {
        var _this = this;
        var _a = this.physics.tick(performance.now()), v = _a.v, dt = _a.dt, wheelstart = _a.wheelstart, wheelend = _a.wheelend;
        wheelstart && this.cb.wheelstart && this.cb.wheelstart(new InertialWheelStartEvent());
        this.cb.wheel && this.cb.wheel(new InertialWheelEvent(this.normalize * dt * v, this.lastNativeEvent));
        wheelend && this.cb.wheelend && this.cb.wheelend(new InertialWheelEndEvent());
        wheelend || this.cb.setNextTick(function () { return _this.tick(); });
    };
    return InertialWheel;
}());
exports.InertialWheel = InertialWheel;
var InertialWheelEvent = /** @class */ (function () {
    function InertialWheelEvent(v, originalEvent) {
        this.v = v;
        this.originalEvent = originalEvent;
    }
    return InertialWheelEvent;
}());
exports.InertialWheelEvent = InertialWheelEvent;
var InertialWheelStartEvent = /** @class */ (function () {
    function InertialWheelStartEvent() {
    }
    return InertialWheelStartEvent;
}());
exports.InertialWheelStartEvent = InertialWheelStartEvent;
var InertialWheelEndEvent = /** @class */ (function () {
    function InertialWheelEndEvent() {
    }
    return InertialWheelEndEvent;
}());
exports.InertialWheelEndEvent = InertialWheelEndEvent;
function defaultSetNextTick() {
    var rafId;
    return function (tick) {
        if (rafId === undefined) {
            rafId = requestAnimationFrame(function () {
                rafId = undefined;
                tick();
            });
        }
    };
}


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = require("@hscmap/magic-trackpad-detector");

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Canvas = void 0;
var gl_wrapper_1 = __webpack_require__(3);
var angle_1 = __webpack_require__(5);
var Canvas = /** @class */ (function () {
    function Canvas(globe, preserveBuffer) {
        if (preserveBuffer === void 0) { preserveBuffer = false; }
        this.globe = globe;
        this.preserveBuffer = preserveBuffer;
        try {
            var _a = gl_wrapper_1.canvasPool.pull({
                alpha: false,
                antialias: false,
                stencil: true,
                premultipliedAlpha: false,
                preserveDrawingBuffer: preserveBuffer,
            }), canvas = _a.canvas, gl = _a.gl;
            this.domElement = canvas;
            this.gl = gl;
            canvas.style.backgroundColor = '#000';
            canvas.style.width = canvas.style.height = '100%';
            canvas.style.display = 'block';
        }
        catch (e) {
            var message = "Fails on initializing WebGL. " + e;
            alert(message);
            throw new Error(message);
        }
    }
    Canvas.prototype.release = function () {
        gl_wrapper_1.canvasPool.push(this.domElement);
    };
    Canvas.prototype.resize = function (retina) {
        var canvas = this.domElement;
        var r = retina ? devicePixelRatio : 1;
        var w = r * canvas.clientWidth;
        var h = r * canvas.clientHeight;
        canvas.width = w;
        canvas.height = h;
        this.gl.viewport(0, 0, w, h);
    };
    Canvas.prototype.setSize = function (w, h) {
        var canvas = this.domElement;
        canvas.width = w;
        canvas.height = h;
        this.gl.viewport(0, 0, w, h);
    };
    Object.defineProperty(Canvas.prototype, "aspectRatio", {
        get: function () {
            var c = this.domElement;
            var a = c.width / c.height;
            return isNaN(a) ? 1 : a;
        },
        enumerable: false,
        configurable: true
    });
    Canvas.prototype.coordFromClientCoord = function (e) {
        return angle_1.EquatorialCoord.fromXyz(this.xyzFromClientCoord(e));
    };
    Canvas.prototype.xyzFromClientCoord = function (e) {
        return this.xyzFromNdc(this.ndcFromClientCoord(e));
    };
    Canvas.prototype.xyzFromOffset = function (x, y) {
        return this.xyzFromNdc(this.ndcFromOffset(x, y));
    };
    Canvas.prototype.coordFromOffset = function (x, y) {
        return angle_1.EquatorialCoord.fromXyz(this.xyzFromOffset(x, y));
    };
    Canvas.prototype.xyzFromNdc = function (_a) {
        var ndx = _a[0], ndy = _a[1];
        return this.globe.viewFactory.view().camera.ndc2sphereXYZ(ndx, ndy, true);
    };
    Canvas.prototype.ndcFromClientCoord = function (e) {
        var clientRect = this.domElement.getBoundingClientRect();
        var _a = [e.clientX - clientRect.left, e.clientY - clientRect.top], x = _a[0], y = _a[1];
        return this.ndcFromOffset(x, y);
    };
    Canvas.prototype.ndcFromOffset = function (x, y) {
        return [
            2 * x / this.domElement.clientWidth - 1,
            1 - 2 * y / this.domElement.clientHeight,
        ];
    };
    Object.defineProperty(Canvas.prototype, "pixelData", {
        get: function () {
            if (!this.preserveBuffer) {
                throw new Error('this.offscreen must be true');
            }
            var gl = this.gl;
            var w = gl.drawingBufferWidth;
            var h = gl.drawingBufferHeight;
            var array = new Uint8Array(w * h * 4);
            gl.finish();
            gl.readPixels(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight, gl.RGBA, gl.UNSIGNED_BYTE, array);
            return {
                width: w,
                height: h,
                buffer: array.buffer,
            };
        },
        enumerable: false,
        configurable: true
    });
    return Canvas;
}());
exports.Canvas = Canvas;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewFactory = exports.MAX_FOVY = exports.MIN_FOVY = void 0;
var tslib_1 = __webpack_require__(0);
var angle_1 = __webpack_require__(5);
var easing = tslib_1.__importStar(__webpack_require__(44));
var gl_matrix_1 = __webpack_require__(1);
var math_1 = __webpack_require__(2);
var view_1 = __webpack_require__(23);
var camera_1 = __webpack_require__(45);
var matrilx_utils_1 = __webpack_require__(11);
exports.MIN_FOVY = angle_1.asec2rad(5);
exports.MAX_FOVY = 2;
var ViewFactory = /** @class */ (function () {
    function ViewFactory(globe, retina) {
        if (retina === void 0) { retina = true; }
        this.globe = globe;
        this.retina = retina;
        this.aspectRatio = -1;
        this.mode = matrilx_utils_1.CameraMode.STEROGRAPHIC;
        this.theta = 0;
        this.phi = 0;
        this.fovy = angle_1.deg2rad(45);
        this.roll = 0;
        this.lodBias = 0;
        this.za = 0;
        this.zd = Math.PI / 2;
        this.zp = 0;
        this.setLodHooks();
    }
    ViewFactory.prototype.coord2thetaphi = function (coord) {
        var v = gl_matrix_1.vec3.transformMat3(gl_matrix_1.vec3.create(), coord.xyz, matrilx_utils_1.zenith3(this.za, this.zd, this.zp));
        return math_1.xyz2thetaphi(v[0], v[1], v[2]);
    };
    ViewFactory.prototype.xyz2thetaphi = function (v) {
        return this.coord2thetaphi(angle_1.EquatorialCoord.fromXyz(v));
    };
    ViewFactory.prototype.thetaphi2xyz = function (theta, phi) {
        return gl_matrix_1.vec3.transformMat3([0, 0, 0], math_1.thetaphi2xyz(theta, phi), matrilx_utils_1.izenith3(this.za, this.zd, this.zp));
    };
    ViewFactory.prototype.thetaphi2coord = function (theta, phi) {
        return angle_1.EquatorialCoord.fromXyz(this.thetaphi2xyz(theta, phi));
    };
    ViewFactory.prototype.center = function () {
        return this.thetaphi2coord(this.theta, this.phi);
    };
    ViewFactory.prototype.jumpTo = function (params2, options) {
        var _a;
        var _this = this;
        if (options === void 0) { options = {}; }
        var duration = options.duration || 400;
        var easingFunction = options.easingFunction || easing.fastStart4;
        this.globe.stopCameraMotion();
        var p1 = {
            aspectRatio: this.aspectRatio,
            theta: this.theta,
            phi: this.phi,
            fovy: this.fovy,
            roll: this.roll,
            mode: this.mode,
            za: this.za,
            zd: this.zd,
            zp: this.zp,
        };
        var p2 = tslib_1.__assign(tslib_1.__assign({}, p1), params2);
        if (options.coord) {
            var v = gl_matrix_1.vec3.transformMat3(gl_matrix_1.vec3.create(), options.coord.xyz, matrilx_utils_1.zenith3(p2.za, p2.zd, p2.zp));
            _a = math_1.xyz2thetaphi(v[0], v[1], v[2]), p2.theta = _a[0], p2.phi = _a[1];
        }
        p1.mode !== p2.mode && this.changeMode(p2.mode, duration);
        p1.phi = angle_1.wrapTo2Pi(p1.phi);
        if (Math.abs(p1.phi - p2.phi) > Math.PI) {
            if (p1.phi > p2.phi) {
                p2.phi += 2 * Math.PI;
            }
            else {
                p1.phi += 2 * Math.PI;
            }
        }
        var distance = gl_matrix_1.vec3.distance(math_1.thetaphi2xyz(p1.theta, p1.phi), math_1.thetaphi2xyz(p2.theta, p2.phi));
        return this.jumpAnimation = this.globe.animation(function (_a) {
            var ratio = _a.r;
            var r = easingFunction(ratio);
            _this.phi = r * p2.phi + (1 - r) * p1.phi;
            _this.theta = r * p2.theta + (1 - r) * p1.theta;
            var f = 1 - Math.pow((2 * (r - 0.5)), 2);
            _this.fovy = options.keepFovy ?
                (1 - r) * p1.fovy + r * p2.fovy : f * Math.max(distance - 2 * p1.fovy, 0) + (1 - r) * p1.fovy + r * p2.fovy;
            _this.roll = (1 - r) * p1.roll + r * p2.roll;
            _this.za = (1 - r) * p1.za + r * p2.za;
            _this.zd = (1 - r) * p1.zd + r * p2.zd;
            _this.zp = (1 - r) * p1.zp + r * p2.zp;
        }, { duration: duration, cameraMotion: true }).then(function () { return _this.jumpAnimation = undefined; });
    };
    ViewFactory.prototype.view = function () {
        return new view_1.View(
        // @ts-ignore
        new camera_1.Camera(this.modeTransitionPv || this.pv()), this.lodBias, this.retina, this.globe.gl.drawingBufferHeight);
    };
    ViewFactory.prototype.pv = function (mode) {
        if (mode === void 0) { mode = this.mode; }
        return (this.customPvMatrix || matrilx_utils_1.cameraMatrix)({
            aspectRatio: this.aspectRatio,
            theta: this.theta,
            phi: this.phi,
            fovy: this.fovy,
            roll: this.roll,
            mode: mode,
            za: this.za,
            zd: this.zd,
            zp: this.zp,
        });
    };
    ViewFactory.prototype.changeMode = function (mode, duration) {
        var _this = this;
        if (duration === void 0) { duration = 200; }
        var oldMode = this.mode;
        this.modeAnimation && this.modeAnimation.stop();
        this.mode = mode;
        this.modeAnimation = this.globe.animation(function (_a) {
            var r = _a.r;
            r = easing.fastStart4(r);
            // @ts-ignore
            _this.modeTransitionPv = matrilx_utils_1.composite([1 - r, r], [_this.pv(oldMode), _this.pv()]);
        }, { duration: duration, immediate: true, cameraMotion: true }).then(function () {
            _this.modeAnimation = undefined;
            _this.modeTransitionPv = undefined;
        });
    };
    ViewFactory.prototype.cage = function () {
        var _this = this;
        if (this.cageAnimation === undefined && (this.fovy < exports.MIN_FOVY || exports.MAX_FOVY < this.fovy)) {
            this.cageAnimation = this.globe.animation(function (_a) {
                var dt = _a.dt;
                if (exports.MIN_FOVY <= _this.fovy && _this.fovy <= exports.MAX_FOVY) {
                    _this.cageAnimation.stop();
                    return;
                }
                var k = 5.e-3;
                var base = _this.fovy > exports.MAX_FOVY ? exports.MAX_FOVY : exports.MIN_FOVY;
                var d = Math.log(_this.fovy / base);
                d += (d < 0 ? -1 : 1) * 1.e-3;
                _this.fovy *= Math.exp(-k * dt * d);
            }, { cameraMotion: true }).then(function () { return _this.cageAnimation = undefined; });
        }
    };
    ViewFactory.prototype.setLodHooks = function () {
        var _this = this;
        this.globe.ee.on('camera-move-start', function () {
            if (_this.lodAnimcation) {
                _this.lodAnimcation.stop();
            }
            _this.lodBias = 1;
        });
        this.globe.ee.on('camera-move-end', function () {
            _this.lodAnimcation = _this.globe.animation(function (_a) {
                var r = _a.r;
                return _this.lodBias = 1 - r;
            }, { duration: 200 }).then(function () {
                _this.lodAnimcation = undefined;
            });
        });
    };
    ViewFactory.prototype.setRetina = function (retina) {
        this.retina = retina;
        this.globe.resize();
        this.globe.requestRefresh();
    };
    return ViewFactory;
}());
exports.ViewFactory = ViewFactory;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = require("@hscmap/easing");

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Camera = void 0;
var gl_matrix_1 = __webpack_require__(1);
var math_1 = __webpack_require__(2);
var Camera = /** @class */ (function () {
    function Camera(pv) {
        this.pv = pv;
        var b = this.iPv = gl_matrix_1.mat4.invert(gl_matrix_1.mat4.create(), pv) || gl_matrix_1.mat4.create();
        var e = [b[8] / b[11], b[9] / b[11], b[10] / b[11]]; // eye position
        var d = [b[12] - (b[8] * b[15]) / b[11], b[13] - (b[9] * b[15]) / b[11], b[14] - (b[10] * b[15]) / b[11]];
        // |this.direction| == 1 if pv does not have scale matrix in its factors
        var up = [b[4] - (b[7] * b[8]) / b[11], b[5] - (b[7] * b[9]) / b[11], b[6] - (b[7] * b[10]) / b[11]];
        var right = [b[0] - (b[3] * b[8]) / b[11], b[1] - (b[3] * b[9]) / b[11], b[2] - (b[3] * b[10]) / b[11]];
        // @ts-ignore
        var upLen = gl_matrix_1.vec3.len(up);
        // @ts-ignore
        var AR = gl_matrix_1.vec3.len(right) / upLen; // aspect ratio
        var ed = gl_matrix_1.vec3.dot(e, d);
        var fovy = 2 * upLen; // ( / |d| )
        var t = (-ed + Math.sqrt(ed * ed - gl_matrix_1.vec3.sqrLen(e) + 1)); // e + t * d : fovCenter
        var arc = fovy * t;
        this.eyePosition = e;
        this.direction = d;
        this.aspectRatio = AR;
        this.fovy = fovy;
        this.arc = arc;
        this.radius = this.arc * Math.sqrt(1 + AR * AR) / 2;
        this.fovCenter = [e[0] + t * d[0], e[1] + t * d[1], e[2] + t * d[2]];
        this.ed = ed;
    }
    /*
    b11(00) b12(04) b13(08) b14(12)
    b21(01) b22 ...
    ...
    b41(03) b42(07) b43(11) b44(15)
    */
    Camera.prototype.ndc2xyz = function (ndx, ndy, ndz) {
        var b = this.iPv;
        var y4 = 1 / (b[3] * ndx + b[7] * ndy + b[11] * ndz + b[15]);
        var x = gl_matrix_1.vec4.transformMat4([0, 0, 0, 0], [y4 * ndx, y4 * ndy, y4 * ndz, y4], b);
        return [x[0], x[1], x[2]];
    };
    Camera.prototype.ndc2sphereXYZ = function (ndx, ndy, safe, r0) {
        if (safe === void 0) { safe = false; }
        if (r0 === void 0) { r0 = 1; }
        var p = this.ndc2xyz(ndx, ndy, -1);
        var q = this.ndc2xyz(ndx, ndy, 1);
        var s = math_1.diff(p, q);
        // a t**2 + 2*b*t + c == 0
        var a = math_1.dot(s, s);
        var b = math_1.dot(s, q);
        var c = math_1.dot(q, q) - (r0 * r0);
        var D = b * b - a * c;
        var t = (-b - Math.sqrt(safe ? Math.abs(D) : D)) / a;
        return [
            t * p[0] + (1 - t) * q[0],
            t * p[1] + (1 - t) * q[1],
            t * p[2] + (1 - t) * q[2],
        ];
    };
    return Camera;
}());
exports.Camera = Camera;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = require("wolfy87-eventemitter");

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = require("hammerjs");

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Renderer = void 0;
var tslib_1 = __webpack_require__(0);
var cache_map_1 = __webpack_require__(12);
var gl_wrapper_1 = __webpack_require__(3);
var healpix = tslib_1.__importStar(__webpack_require__(27));
var gl_matrix_1 = __webpack_require__(1);
var math_1 = __webpack_require__(2);
var healpix_1 = __webpack_require__(13);
var shiftmap = tslib_1.__importStar(__webpack_require__(49));
var MIN_TILE_ORDER = 2;
var Renderer = /** @class */ (function () {
    function Renderer(globe, textureProvider) {
        this.globe = globe;
        this.textureProvider = textureProvider;
        this.alpha = 1;
        this.animationLod = 0;
        this.lodBias = 0;
        this.integerOrder = false;
        this.tileCache = new cache_map_1.CacheMap(5000, function (t) { return t.release(); });
        var gl = this.gl = this.globe.gl;
        this.program = gl_wrapper_1.Program.new(this.gl, __webpack_require__(52).default, __webpack_require__(53).default);
        this.attribList = new gl_wrapper_1.AttribList(this.gl, {
            members: [{ name: 'a_coord', nComponents: 2 }],
            array: this.buildArray(),
        });
        this.zeroTexture = new gl_wrapper_1.Texture(gl);
        this.zeroTexture.bind(function () {
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, 1, 1, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, new Uint8Array([128]));
        });
        for (var i = MIN_TILE_ORDER; i < 5; ++i) {
            shiftmap.preload(i);
        }
    }
    Renderer.prototype.release = function () {
        this.program.release();
        this.attribList.release();
        this.zeroTexture.release();
        this.tileCache.clear();
    };
    Renderer.prototype.render = function (view) {
        var _this = this;
        if (this.alpha <= 0) {
            return;
        }
        this.activateProgram(function () {
            var _a = _this, gl = _a.gl, program = _a.program;
            program.uniformMatrix4fv({ u_pvMatrix: view.camera.pv });
            program.uniformMatrix3fv({ u_rotMatrix: _this.textureProvider.coordFrame.mat });
            program.uniform1i({ u_shiftmap: 0 });
            program.uniform1i({ u_texture1: 1 });
            var order = _this.visibleTiles(view, function (rOrder, hid) {
                var tile = _this.tileCache.get(hid);
                if (!tile) {
                    tile = new Tile(_this, hid);
                    _this.tileCache.set(hid, tile);
                }
                tile.render(rOrder);
            });
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, null);
            gl.activeTexture(gl.TEXTURE1);
            gl.bindTexture(gl.TEXTURE_2D, null);
            order > MIN_TILE_ORDER && shiftmap.preload(order - 1);
            shiftmap.preload(order + 1);
            gl.activeTexture(gl.TEXTURE0);
        });
        this.textureProvider.flushQueue(this.textureProvider.coordFrame.invert(view.camera.direction));
    };
    Renderer.prototype.draw = function () {
        var gl = this.gl;
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, this.attribList.vertexCount);
    };
    Renderer.prototype.visibleTiles = function (view, cb) {
        var _a = this.textureProvider, minTileOrder = _a.minTileOrder, maxTileOrder = _a.maxTileOrder, tileOrder = _a.tileOrder;
        var rOrder = math_1.clamp(this.realOrder(view) - tileOrder - (this.lodBias + this.animationLod * view.lodBias), minTileOrder, maxTileOrder);
        if (this.integerOrder) {
            rOrder = Math.floor(rOrder);
        }
        var order = Math.ceil(math_1.clamp(rOrder, MIN_TILE_ORDER, maxTileOrder));
        var nside = 1 << order;
        query_disc_inclusive_nest(this.textureProvider.coordFrame, nside, view.camera.direction, view.camera.radius, function (index) {
            cb(rOrder, healpix.orderpix2uniq(order, index));
        });
        return order;
    };
    Renderer.prototype.realOrder = function (view) {
        var arc = view.camera.arc;
        return Math.log(Math.sqrt(Math.PI / 3) * this.globe.gl.drawingBufferHeight / arc) / Math.LN2;
    };
    Renderer.prototype.activateProgram = function (cb) {
        var gl = this.gl;
        this.program.use();
        this.attribList.enable(this.program, function () {
            gl_wrapper_1.utils.enable(gl, [gl.BLEND], function () {
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                cb();
            });
        });
    };
    Renderer.prototype.buildArray = function () {
        var a = [];
        var step = 32;
        for (var i = 0; i < step; ++i) {
            var y = i / step;
            var y2 = (i + 1) / step;
            for (var j = 0; j <= step; ++j) {
                var x = j / step;
                for (var k = step > 1 && j === 0 ? 2 : 1; k !== 0; --k) {
                    a.push(y2, x);
                }
                for (var k = step > 1 && j === step ? 2 : 1; k !== 0; --k) {
                    a.push(y, x);
                }
            }
        }
        return new Float32Array(a);
    };
    return Renderer;
}());
exports.Renderer = Renderer;
function query_disc_inclusive_nest(cf, nside, center, radius, cb) {
    center = cf.invert(center);
    if (radius > Math.PI / 2) {
        var n = 12 * nside * nside;
        for (var i = 0; i < n; ++i) {
            cb(i);
        }
    }
    else {
        healpix.query_disc_inclusive_nest(nside, center, radius, cb);
    }
}
var Tile = /** @class */ (function () {
    function Tile(renderer, hid) {
        var _this = this;
        this.renderer = renderer;
        this.hid = hid;
        this.alreadyReleased = false;
        var _a = healpix.uniq2orderpix(hid), order = _a.order, index = _a.ipix;
        this.order = order;
        this.index = index;
        this.coeff = healpix_1.coeff(order, index);
        this.isBeltEnd = Tile.isBeltEnd(order, index);
        if (shiftmap.needShiftMap(order, index)) {
            shiftmap.fetch(order, index, function (arr) {
                if (!_this.alreadyReleased) {
                    var gl_1 = _this.renderer.globe.gl;
                    _this.shiftmap = new gl_wrapper_1.Texture(gl_1);
                    _this.shiftmap.bind(function () {
                        var size = shiftmap.size;
                        gl_1.texImage2D(gl_1.TEXTURE_2D, 0, gl_1.RGB, size, size, 0, gl_1.RGB, gl_1.UNSIGNED_BYTE, arr);
                    });
                }
            });
        }
    }
    Tile.prototype.release = function () {
        this.alreadyReleased = true;
        if (this.shiftmap) {
            this.shiftmap.release();
        }
    };
    Tile.prototype.render = function (rOrder) {
        var _this = this;
        var _a = this.renderer, gl = _a.gl, program = _a.program;
        program.uniform1f({ u_belt_end: this.isBeltEnd ? 1 : 0 });
        program.uniformMatrix4fv({
            u_ax: this.coeff.a[0],
            u_ay: this.coeff.a[1],
            u_az: this.coeff.a[2],
        });
        if (this.isBeltEnd) {
            program.uniformMatrix4fv({
                u_bx: this.coeff.b[0],
                u_by: this.coeff.b[1],
                u_bz: this.coeff.b[2],
            });
        }
        this.textures(rOrder, function (tt, tMatrix, textureAlpha) {
            // tslint:disable-next-line:variable-name
            var u_alpha = _this.renderer.alpha * textureAlpha;
            program.uniform1f({ u_alpha: u_alpha });
            program.uniformMatrix3fv({ u_tMatrix: tMatrix });
            gl.activeTexture(gl.TEXTURE1);
            gl.bindTexture(gl.TEXTURE_2D, tt.tex.name);
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, (_this.shiftmap || _this.renderer.zeroTexture).name);
            _this.renderer.draw();
        });
    };
    Tile.isBeltEnd = function (order, index) {
        var nside = 1 << order;
        var nside2 = nside * nside;
        var f = Math.floor(index / nside2);
        var _a = healpix.bit_decombine(index % nside2), x = _a.x, y = _a.y;
        return (f < 4 || 8 <= f) && x + y === nside - 1;
    };
    Tile.prototype.textures = function (rOrder, cb) {
        var tp = this.renderer.textureProvider;
        var tMaxOrder = Math.ceil(rOrder);
        var order = this.order;
        var index = this.index;
        var tMatrix = gl_matrix_1.mat3.create();
        var beta = 1;
        while (order >= tp.minTileOrder) {
            if (order <= tMaxOrder) {
                var hid = healpix.orderpix2uniq(order, index);
                var tt = tp.get(hid);
                if (tt) {
                    var alpha = (tMaxOrder === order ? 1 + rOrder - order : 1) * tt.fadeAlpha;
                    var invTMatrix = gl_matrix_1.mat3.invert(gl_matrix_1.mat3.create(), tMatrix);
                    cb(tt, invTMatrix, alpha * beta);
                    beta *= 1 - alpha;
                    if (alpha >= 1) {
                        break;
                    }
                }
                else {
                    tp.request(hid);
                }
            }
            gl_matrix_1.mat3.scale(tMatrix, tMatrix, [2, 2]);
            gl_matrix_1.mat3.translate(tMatrix, tMatrix, [index & 2 ? -0.5 : 0, index & 1 ? 0 : -0.5]);
            --order;
            index >>= 2;
        }
    };
    return Tile;
}());


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.preload = exports.needShiftMap = exports.fetch = void 0;
// tslint:disable-next-line:no-var-requires variable-name
var ShiftmapWorker = __webpack_require__(50);
var healpix_1 = __webpack_require__(13);
var interface_1 = __webpack_require__(51);
Object.defineProperty(exports, "size", { enumerable: true, get: function () { return interface_1.DELTA_MAP_N; } });
function fetch(order, index, then) {
    var id = healpix_1.shiftmapId(order, index);
    if (workerManager.cache.has(id)) {
        then(workerManager.cache.get(id));
    }
    else {
        workerManager.enqueue(id).then(then);
    }
}
exports.fetch = fetch;
var ShitmapWorkerManager = /** @class */ (function () {
    function ShitmapWorkerManager() {
        this.cache = new Map();
        this.resolve = new Map();
        this.queue = [];
    }
    ShitmapWorkerManager.prototype.enqueue = function (id) {
        var _this = this;
        if (this.cache.has(id)) {
            return Promise.resolve(this.cache.get(id));
        }
        if (this.processing !== id && this.queue.indexOf(id) < 0) {
            this.queue.push(id);
            this.doNextJob();
        }
        return new Promise(function (resolve) {
            if (!_this.resolve.has(id)) {
                _this.resolve.set(id, []);
            }
            _this.resolve.get(id).push(resolve);
        });
    };
    ShitmapWorkerManager.prototype.receiveShiftmap = function (_a) {
        var id = _a.id, arraybuffer = _a.arraybuffer;
        var array = new Uint8Array(arraybuffer);
        var i = this.queue.indexOf(id);
        if (i >= 0) {
            this.queue.splice(i, 1);
        }
        this.cache.set(id, array);
        if (this.resolve.has(id)) {
            for (var _i = 0, _b = this.resolve.get(id); _i < _b.length; _i++) {
                var r = _b[_i];
                r(array);
            }
            this.resolve.delete(id);
        }
    };
    ShitmapWorkerManager.prototype.doNextJob = function () {
        if (this.processing === undefined) {
            var id = this.queue.shift();
            if (id !== undefined) {
                var req = { id: id };
                this.startWorker();
                this.processing = id;
                this.worker.postMessage(req);
            }
            else {
                this.requestQuitWorker();
            }
        }
    };
    ShitmapWorkerManager.prototype.startWorker = function () {
        var _this = this;
        if (!this.worker) {
            this.cancelQuit();
            this.worker = new ShiftmapWorker();
            this.worker.addEventListener('message', function (e) {
                var res = e.data;
                for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
                    var shiftmap = res_1[_i];
                    _this.receiveShiftmap(shiftmap);
                }
                _this.processing = undefined;
                _this.doNextJob();
            });
        }
    };
    ShitmapWorkerManager.prototype.cancelQuit = function () {
        if (this.quitTimer !== undefined) {
            clearTimeout(this.quitTimer);
            this.quitTimer = undefined;
        }
    };
    ShitmapWorkerManager.prototype.requestQuitWorker = function () {
        var _this = this;
        this.cancelQuit();
        this.quitTimer = setTimeout(function () {
            _this.quitTimer = undefined;
            _this.worker.terminate();
            _this.worker = undefined;
        }, 5000);
    };
    return ShitmapWorkerManager;
}());
// true for polar caps
function needShiftMap(order, index) {
    var nside = 1 << order;
    var nside2 = nside * nside;
    var f = Math.floor(index / nside2);
    if (4 <= f && f < 8) {
        return false;
    }
    var i = f >= 8 ? index % nside2 : nside2 - (index % nside2) - 1;
    return [0, 1, 2, 3].indexOf(i) >= 0;
}
exports.needShiftMap = needShiftMap;
var workerManager = new ShitmapWorkerManager();
function preload(order) {
    if (order === 0) {
        workerManager.enqueue(healpix_1.encode_id(0, 0));
        workerManager.enqueue(healpix_1.encode_id(0, 8));
    }
    else {
        var n2 = 1 << (2 * order);
        for (var i = 0; i < 4; ++i) {
            workerManager.enqueue(healpix_1.shiftmapId(order, n2 - i - 1)); // north cap
            workerManager.enqueue(healpix_1.shiftmapId(order, 8 * n2 + i)); // south cap
        }
    }
}
exports.preload = preload;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "d76e371f1017dc82e29b.worker.js");
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DELTA_MAP_N = void 0;
exports.DELTA_MAP_N = 64; // see frag.vert.glsl


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\nattribute  vec2   a_coord;\nuniform    mat4   u_pvMatrix;\nuniform    mat3   u_rotMatrix;\nuniform    mat3   u_tMatrix;\nuniform    float  u_belt_end;\nuniform    mat4   u_ax, u_ay, u_az;\nuniform    mat4   u_bx, u_by, u_bz;\nvarying    vec2   v_coord;\nvarying    float  v_w;\n\n\nvoid main(void) {\n    float p = a_coord.x;\n    float q = a_coord.y;\n    float p2 = p*p,  q2 = q*q;\n    float p3 = p2*p, q3 = q2*q;\n    float p4 = p3*p, q4 = q3*q;\n    vec4 P = vec4(p3, p2, p, 1.);\n    vec4 Q = vec4(q3, q2, q, 1.);\n    vec3 position;\n    vec3 a = vec3(\n        dot(P, u_ax * Q),\n        dot(P, u_ay * Q),\n        dot(P, u_az * Q)\n    );\n    vec3 b = vec3(\n        dot(P, u_bx * Q),\n        dot(P, u_by * Q),\n        dot(P, u_bz * Q)\n    );\n    position = mix(a, b, step(0., u_belt_end * (q - p) - 1./128.));\n    gl_Position = u_pvMatrix * vec4(u_rotMatrix * position, 1.);\n    v_coord = a_coord;\n    v_w = gl_Position.w;\n}");

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\nuniform   sampler2D  u_texture1;\nuniform   sampler2D  u_shiftmap;\nuniform   mat3       u_tMatrix;\nuniform   float      u_alpha;\nvarying   vec2       v_coord;\nvarying   float      v_w;\n\n/*\n    // TypeScript\n    function encode(v: number) {\n        const VMAX = 0.015\n        return ((v / VMAX) + 1) / 2 * 256\n    }\n*/\n\nconst float VMAX = 0.015;\nvec2 decode_shiftmap(vec2 e) {\n    e *= 255. / 256.;\n    return (2. * e - 1.) * VMAX;\n}\n\nconst float DELTA_MAP_N = 64.;\nvec2 delta_coord(vec2 c) {\n    return (1./DELTA_MAP_N)*((DELTA_MAP_N-1.)*c + vec2(0.5));\n}\n\n\nvoid main() {\n    vec2 tCoord = (u_tMatrix * vec3(v_coord - decode_shiftmap(texture2D(u_shiftmap, delta_coord(v_coord)).xy), 1)).xy;\n    gl_FragColor = texture2D(u_texture1, tCoord);\n    gl_FragColor.a *= u_alpha * clamp(4. * (v_w - 0.2), 0., 1.);\n    // vec2 d = pow(2. * (v_coord - vec2(0.5)), vec2(10.));\n    // gl_FragColor.g += 0.75 * dot(d, d);\n}");

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordFrame = void 0;
var gl_matrix_1 = __webpack_require__(1);
// Reconsidering the Galactic coordinate system
// J.-C. Liu, Z. Zhu, and H. Zhang
// A&A 526, A16 (2011)
// https://www.aanda.org/articles/aa/pdf/2011/02/aa14961-10.pdf
var g2e = gl_matrix_1.mat3.fromValues(// N_J (9)
-0.054875539390, -0.873437104725, -0.483834991775, +0.494109453633, -0.444829594298, +0.746982248696, -0.867666135681, -0.198076389622, +0.455983794523);
var CoordFrame = /** @class */ (function () {
    function CoordFrame(mat) {
        this.mat = mat;
        this.invMat = gl_matrix_1.mat3.transpose(gl_matrix_1.mat3.create(), mat);
    }
    CoordFrame.prototype.rotate = function (v) {
        return gl_matrix_1.vec3.transformMat3([0, 0, 0], v, this.mat);
    };
    CoordFrame.prototype.invert = function (v) {
        return gl_matrix_1.vec3.transformMat3([0, 0, 0], v, this.invMat);
    };
    CoordFrame.GALACTIC = new CoordFrame(g2e);
    CoordFrame.EQUATORIAL = new CoordFrame(gl_matrix_1.mat3.identity(gl_matrix_1.mat3.create()));
    return CoordFrame;
}());
exports.CoordFrame = CoordFrame;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleImageTextureProvider = exports.AsyncTextureProvider = exports.TextureRef = exports.TileTexture = exports.TextureProvider = void 0;
var tslib_1 = __webpack_require__(0);
var cache_map_1 = __webpack_require__(12);
// import { Fits } from '@hscmap/fits'
var gl_wrapper_1 = __webpack_require__(3);
var healpix = tslib_1.__importStar(__webpack_require__(27));
var gl_matrix_1 = __webpack_require__(1);
var image_1 = __webpack_require__(6);
var matrilx_utils_1 = __webpack_require__(11);
var _1 = __webpack_require__(26);
var healpix_1 = __webpack_require__(13);
var properties_1 = __webpack_require__(56);
var TextureProvider = /** @class */ (function () {
    function TextureProvider(globe, tileOrder, maxTileOrder, minTileOrder, coordFrame) {
        this.globe = globe;
        this.tileOrder = tileOrder;
        this.maxTileOrder = maxTileOrder;
        this.minTileOrder = minTileOrder;
        this.coordFrame = coordFrame;
    }
    return TextureProvider;
}());
exports.TextureProvider = TextureProvider;
var TileTexture = /** @class */ (function () {
    function TileTexture(tp) {
        var _this = this;
        this.fadeAlpha = 0;
        var gl = tp.globe.gl;
        this.tex = new gl_wrapper_1.Texture(gl);
        tp.globe.animation((function (_a) {
            var r = _a.r;
            _this.fadeAlpha = r;
        }), { duration: 200 });
    }
    TileTexture.prototype.release = function () {
        this.tex.release();
    };
    TileTexture.prototype.bind = function (cb) {
        this.tex.bind(cb);
    };
    return TileTexture;
}());
exports.TileTexture = TileTexture;
var TextureRef = /** @class */ (function () {
    function TextureRef(hid) {
        this.hid = hid;
        var _a = healpix.uniq2orderpix(hid), order = _a.order, ipix = _a.ipix;
        this.order = order;
        this.index = ipix;
        this.center = healpix.pix2vec_nest(1 << order, ipix);
    }
    return TextureRef;
}());
exports.TextureRef = TextureRef;
var AsyncTextureProvider = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncTextureProvider, _super);
    function AsyncTextureProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = new cache_map_1.CacheMap(1000, function (tt) { return tt.release(); });
        _this.alreadyReleased = false;
        _this.refsToLoad = new Map();
        _this.refsInLoading = new Map();
        _this.deadHid = new Set();
        _this.nParallel = 4;
        return _this;
    }
    AsyncTextureProvider.prototype.release = function () {
        this.alreadyReleased = true;
        this.cache.clear();
    };
    AsyncTextureProvider.prototype.get = function (hid) {
        return this.cache.get(hid);
    };
    AsyncTextureProvider.prototype.request = function (hid) {
        if (!this.deadHid.has(hid) && !this.refsInLoading.has(hid) && !this.refsToLoad.has(hid)) {
            var ref = new TextureRef(hid);
            this.refsToLoad.set(hid, ref);
        }
    };
    AsyncTextureProvider.prototype.flushQueue = function (center) {
        var _this = this;
        if (this.refsInLoading.size >= this.nParallel) {
            return;
        }
        var refs = [];
        this.refsToLoad.forEach(function (ref) { return refs.push(ref); });
        refs.sort(function (a, b) {
            return a.order !== b.order ? a.order - b.order : gl_matrix_1.vec3.sqrDist(center, a.center) - gl_matrix_1.vec3.sqrDist(center, b.center);
        });
        var _loop_1 = function (ref) {
            if (this_1.refsInLoading.size >= this_1.nParallel) {
                return "break";
            }
            this_1.refsInLoading.set(ref.hid, ref);
            this_1.makeTileTexture(ref).then(function (tt) {
                if (_this.alreadyReleased) {
                    tt.release();
                }
                else {
                    _this.cache.set(ref.hid, tt, ref.order === _this.minTileOrder);
                    _this.globe.requestRefresh();
                }
            }).catch(function (e) {
                _this.deadHid.add(ref.hid);
            }).then(function () {
                _this.refsInLoading.delete(ref.hid);
            });
        };
        var this_1 = this;
        for (var _i = 0, refs_1 = refs; _i < refs_1.length; _i++) {
            var ref = refs_1[_i];
            var state_1 = _loop_1(ref);
            if (state_1 === "break")
                break;
        }
        this.refsToLoad.clear();
    };
    return AsyncTextureProvider;
}(TextureProvider));
exports.AsyncTextureProvider = AsyncTextureProvider;
// export class SimpleFitsTextureProvider extends AsyncTextureProvider {
//     constructor(
//     globe: Globe,
//     readonly baseUrl: string,
//     tileOrder: number,
//     maxTileOrder: number,
//     minTileOrder: number,
//     coordFrame: CoordFrame,
//     ) {
//     super(globe, tileOrder, maxTileOrder, minTileOrder, coordFrame)
//     }
//     async makeTileTexture(ref: TextureRef): Promise<TileTexture> {
//     const url = this.tileId2Url(ref.order, ref.index)
//     const hdul = await Fits.fetch(url, [{ outputDataType: Fits.DataType.float32 }])
//     const tt = new TileTexture(this)
//     tt.bind(() => {
//       const gl = this.globe.gl
//       const hdu = hdul[0]
//       const width = hdu.card('NAXIS1', 'number')
//       const height = hdu.card('NAXIS2', 'number')
//       const array = hdu.float32array()
//       gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, width, height, 0, gl.LUMINANCE, gl.FLOAT, array)
//       if (ref.order == this.minTileOrder) {
//       gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR)
//       gl.generateMipmap(gl.TEXTURE_2D)
//       }
//     })
//     return tt
//     }
//     private tileId2Url(order: number, index: number) {
//     const dir = Math.floor(index / 10000) * 10000
//     return `${this.baseUrl}/Norder${order}/Dir${dir}/Npix${index}.fits`
//     }
// }
var SimpleImageTextureProvider = /** @class */ (function (_super) {
    tslib_1.__extends(SimpleImageTextureProvider, _super);
    function SimpleImageTextureProvider(globe, baseUrl, properties) {
        var _this = this;
        var maxOrder = Number(properties.hips_order);
        var minOrder = properties.hips_order_min ? Number(properties.hips_order_min) : 3;
        var tileSize = Number(properties.hips_tile_width);
        var coordFrame = (function (cf) {
            switch (cf) {
                case 'equatorial': return _1.CoordFrame.EQUATORIAL;
                case 'galactic': return _1.CoordFrame.GALACTIC;
                case 'hsc/zenith':
                case 'zenith':
                    var _a = JSON.parse(properties['hsc/zenith']), a = _a[0], d = _a[1], p = _a[2];
                    return new _1.CoordFrame(matrilx_utils_1.izenith3(a, d, p));
            }
            return _1.CoordFrame.EQUATORIAL;
        })(properties.hips_frame);
        var tileOrder = healpix_1.size2order(tileSize);
        var format = (function (fs) {
            var f = fs.split(/\s+/)[0];
            return { jpeg: 'jpg' }[f] || f;
        })(properties.hips_tile_format);
        _this = _super.call(this, globe, tileOrder, maxOrder, minOrder, coordFrame) || this;
        _this.baseUrl = baseUrl;
        _this.properties = properties;
        _this.format = format;
        return _this;
    }
    SimpleImageTextureProvider.prototype.makeTileTexture = function (ref) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, image, tt, gl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.tileId2Url(ref.order, ref.index);
                        return [4 /*yield*/, image_1.loadImage(url)];
                    case 1:
                        image = _a.sent();
                        tt = new TileTexture(this);
                        gl = this.globe.gl;
                        tt.bind(function () {
                            void gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
                            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
                            void gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 0);
                            if (ref.order === _this.minTileOrder) {
                                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
                                gl.generateMipmap(gl.TEXTURE_2D);
                            }
                        });
                        return [2 /*return*/, tt];
                }
            });
        });
    };
    SimpleImageTextureProvider.prototype.tileId2Url = function (order, index) {
        var dir = Math.floor(index / 10000) * 10000;
        return this.baseUrl + "/Norder" + order + "/Dir" + dir + "/Npix" + index + "." + this.format;
    };
    SimpleImageTextureProvider.fromBaseUrl = function (globe, baseUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var properties;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, properties_1.fetchProperties(baseUrl)];
                    case 1:
                        properties = _a.sent();
                        return [2 /*return*/, new SimpleImageTextureProvider(globe, baseUrl, properties)];
                }
            });
        });
    };
    return SimpleImageTextureProvider;
}(AsyncTextureProvider));
exports.SimpleImageTextureProvider = SimpleImageTextureProvider;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchProperties = void 0;
var tslib_1 = __webpack_require__(0);
var axios_1 = tslib_1.__importDefault(__webpack_require__(28));
function fetchProperties(baseUrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var url, txt, dict, _i, _a, line, _b, k, v;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = baseUrl + "/properties";
                    return [4 /*yield*/, axios_1.default.get(url, { responseType: 'text' })];
                case 1:
                    txt = (_c.sent()).data;
                    dict = {};
                    for (_i = 0, _a = txt.split('\n'); _i < _a.length; _i++) {
                        line = _a[_i];
                        if (!line.match(/^\s*#/)) {
                            if (line.indexOf('=') >= 0) {
                                _b = line.split('=').map(function (s) { return s.replace(/\s*(.*?)\s*$/, '$1'); }), k = _b[0], v = _b[1];
                                dict[k] = v;
                            }
                        }
                    }
                    if (!('hips_order' in dict) || !('hips_tile_width' in dict)) {
                        throw new Error("invalid properties file");
                    }
                    return [2 /*return*/, dict];
            }
        });
    });
}
exports.fetchProperties = fetchProperties;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var renderer_1 = __webpack_require__(58);
Object.defineProperty(exports, "Renderer", { enumerable: true, get: function () { return renderer_1.Renderer; } });
var tract_1 = __webpack_require__(14);
Object.defineProperty(exports, "Tract", { enumerable: true, get: function () { return tract_1.Tract; } });
var texture_provider_1 = __webpack_require__(61);
Object.defineProperty(exports, "TextureProvider", { enumerable: true, get: function () { return texture_provider_1.TextureProvider; } });
Object.defineProperty(exports, "TileRef", { enumerable: true, get: function () { return texture_provider_1.TileRef; } });
Object.defineProperty(exports, "TileTexture", { enumerable: true, get: function () { return texture_provider_1.TileTexture; } });
Object.defineProperty(exports, "AsyncTextureProvider", { enumerable: true, get: function () { return texture_provider_1.AsyncTextureProvider; } });
Object.defineProperty(exports, "SimpleImageTextureProvider", { enumerable: true, get: function () { return texture_provider_1.SimpleImageTextureProvider; } });


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Tile = exports.TractRenderer = exports.Renderer = void 0;
var cache_map_1 = __webpack_require__(12);
var gl_wrapper_1 = __webpack_require__(3);
var gl_matrix_1 = __webpack_require__(1);
var tract_1 = __webpack_require__(14);
var Renderer = /** @class */ (function () {
    function Renderer(globe, textureProvider) {
        this.globe = globe;
        this.textureProvider = textureProvider;
        this.tileCache = new cache_map_1.CacheMap(1000, function (t) { return t.release(); });
        this.deadTileId = new Set();
        this.alpha = 1;
        this.animationLod = 1;
        this.lodBias = 0;
        this.integerLevel = false;
        this.alreadyReleased = false;
        this.tractRenderers = new Map();
        var gl = globe.gl;
        this.gl = gl;
        this.program = gl_wrapper_1.Program.new(this.gl, __webpack_require__(59).default, __webpack_require__(60).default);
        this.attribList = new gl_wrapper_1.AttribList(this.gl, {
            members: [{ name: 'a_coord', nComponents: 2 }],
            array: this.buildArray(),
        });
    }
    Renderer.prototype.release = function () {
        this.attribList.release();
        this.program.release();
        this.alreadyReleased = true;
        this.tileCache.clear();
    };
    Renderer.prototype.render = function (view) {
        var _this = this;
        var tractCount = 0;
        if (this.alpha <= 0) {
            return 0;
        }
        this.activateProgram(function () {
            tractCount = _this.textureProvider.visibleTracts(view, function (tract) {
                var program = _this.program;
                if (!_this.tractRenderers.has(tract)) {
                    _this.tractRenderers.set(tract, new TractRenderer(_this, tract));
                }
                var r = _this.tractRenderers.get(tract);
                program.uniform1f({ u_layer_alpha: _this.alpha });
                program.uniformMatrix4fv({ u_pvMatrix: view.camera.pv });
                r.render(view);
            });
            _this.textureProvider.flushQueue(view.camera.direction);
        });
        return tractCount;
    };
    Renderer.prototype.draw = function () {
        var gl = this.gl;
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, this.attribList.vertexCount);
    };
    Renderer.prototype.activateProgram = function (cb) {
        var _a = this, gl = _a.gl, program = _a.program;
        program.use();
        this.attribList.enable(this.program, function () {
            gl_wrapper_1.utils.enable(gl, [gl.BLEND], function () {
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
                gl.activeTexture(gl.TEXTURE0);
                program.uniform1i({ u_texture0: 0 });
                cb();
                gl.bindTexture(gl.TEXTURE_2D, null);
            });
        });
    };
    Renderer.prototype.buildArray = function () {
        var a = [0, 0, 1, 0, 0, 1, 1, 1];
        return new Float32Array(a);
    };
    Renderer.prototype.clearTiles = function () {
        this.tileCache.clear();
        this.deadTileId.clear();
    };
    Renderer.prototype.clearInvisibleTiles = function (view, lodBias) {
        var _this = this;
        if (lodBias === void 0) { lodBias = 1; }
        var integerLevel = this.integerLevel;
        this.integerLevel = true;
        var visibleTileIds = new Set();
        this.textureProvider.visibleTracts(view, function (tract) {
            var tr = _this.tractRenderers.get(tract);
            if (tr) {
                var tiles = tr.visibleTiles(view, _this.lodBias + lodBias).tiles;
                for (var _i = 0, tiles_1 = tiles; _i < tiles_1.length; _i++) {
                    var tile = tiles_1[_i];
                    visibleTileIds.add(tile.id);
                }
            }
        });
        for (var _i = 0, _a = this.tileCache.keys(); _i < _a.length; _i++) {
            var k = _a[_i];
            if (!visibleTileIds.has(k)) {
                this.tileCache.delete(k);
            }
        }
        this.integerLevel = integerLevel;
        this.deadTileId.clear();
    };
    Renderer.prototype.setCacheSize = function (limit) {
        this.tileCache.setLimit(limit);
    };
    return Renderer;
}());
exports.Renderer = Renderer;
var TractRenderer = /** @class */ (function () {
    function TractRenderer(renderer, tract) {
        this.renderer = renderer;
        this.tract = tract;
    }
    TractRenderer.prototype.render = function (view) {
        var tract = this.tract;
        var _a = this.renderer, lodBias = _a.lodBias, animationLod = _a.animationLod;
        var _b = this.visibleTiles(view, lodBias + animationLod * view.lodBias), tiles = _b.tiles, baseLevel = _b.baseLevel, lodAlpha = _b.lodAlpha;
        tiles.sort(function (a, b) { return b.level - a.level; });
        this.renderer.program.uniformMatrix4fv({ u_mMatrix: tract.mMatrix });
        for (var _i = 0, tiles_2 = tiles; _i < tiles_2.length; _i++) {
            var tile = tiles_2[_i];
            var alpha = !this.renderer.integerLevel && baseLevel === tile.level ? lodAlpha : 1;
            tile.render(alpha);
        }
    };
    TractRenderer.prototype.visibleTiles = function (view, lodBias) {
        var tract = this.tract;
        var tiles = [];
        var done = new Set();
        var _a = tract.tileIndices(view, lodBias), minP = _a.minP, maxP = _a.maxP, minQ = _a.minQ, maxQ = _a.maxQ, baseLevel = _a.baseLevel, lodAlpha = _a.lodAlpha;
        for (var p = minP; p <= maxP; ++p) {
            for (var q = minQ; q <= maxQ; ++q) {
                this.readyTilesFor(baseLevel, p, q, function (tile) {
                    if (!done.has(tile.id)) {
                        tiles.push(tile);
                    }
                    done.add(tile.id);
                });
            }
        }
        return { tiles: tiles, baseLevel: baseLevel, lodAlpha: lodAlpha };
    };
    TractRenderer.prototype.readyTilesFor = function (baseLevel, p, q, cb) {
        var renderer = this.renderer;
        var tract = this.tract;
        var tileCache = renderer.tileCache;
        for (var level = baseLevel; level <= tract.maxTileLevel; ++level) {
            var id = tract.encodeTileId(level, p, q);
            if (renderer.deadTileId.has(id)) {
                return;
            }
            var isRootTile = level === tract.maxTileLevel;
            var tile = tileCache.get(id);
            if (tile) {
                cb(tile);
                tile.tt.needUpdate() && this.requestTile(id, isRootTile, tile);
                if ((renderer.integerLevel || level > baseLevel) && tile.tt.fadeAlpha >= 1) {
                    break;
                }
            }
            else {
                this.requestTile(id, isRootTile);
            }
            p >>= 1;
            q >>= 1;
        }
    };
    TractRenderer.prototype.requestTile = function (id, isRootTile, oldTile) {
        var _this = this;
        var renderer = this.renderer;
        var tp = renderer.textureProvider;
        var priority = oldTile ? oldTile.tt.revision : tp.revision;
        var fetch = tp.fetch(id, priority); // fetch will be undefined if id in tp's queue
        fetch && fetch.then(function (tt) {
            if (renderer.alreadyReleased) {
                tt.release();
            }
            else {
                !oldTile && tt.fadeIn();
                var tile = new Tile(id, tt, renderer);
                renderer.tileCache.set(id, tile, isRootTile);
                _this.renderer.globe.requestRefresh();
            }
        }).catch(function () {
            renderer.deadTileId.add(id);
            _this.renderer.globe.requestRefresh();
        });
    };
    return TractRenderer;
}());
exports.TractRenderer = TractRenderer;
var Tile = /** @class */ (function () {
    // readonly a2mMatrix: mat4
    function Tile(id, tt, renderer) {
        this.id = id;
        this.tt = tt;
        this.renderer = renderer;
        var _a = tract_1.Tract.decodeTileId(id), tract = _a.tract, level = _a.level, p = _a.p, q = _a.q;
        this.level = level;
        var s = tract.tileSize << level;
        var U = (Math.min(((tract.naxis2 >> level) - 1) << level, s * (p + 1)) - s * p) / s;
        var V = (Math.min(((tract.naxis1 >> level) - 1) << level, s * (q + 1)) - s * q) / s;
        this.texMatrix = gl_matrix_1.mat3.fromValues(V, 0, 0, 0, U, 0, 0, 0, 1); // window for texture
        this.tileMatrix = gl_matrix_1.mat3.fromValues(s, 0, 0, 0, s, 0, s * q, s * p, 1);
        // this.a2mMatrix = mat4.mul( // mMatrix * tileMatrix * texMatrix
        //     mat4.create(),
        //     tract.mMatrix,
        //     mat4.fromValues(
        //     V * s, 0, 0, 0,
        //     0, U * s, 0, 0,
        //     0, 0, 1, 0,
        //     q * s, p * s, 0, 1)
        // )
    }
    Tile.prototype.release = function () {
        this.tt.release();
    };
    Tile.prototype.render = function (alpha) {
        var tt = this.tt;
        var renderer = this.renderer;
        var gl = renderer.gl, program = renderer.program;
        gl.bindTexture(gl.TEXTURE_2D, tt.tex.name);
        program.uniform1f({ u_alpha: alpha * this.tt.fadeAlpha });
        program.uniformMatrix3fv({ u_texMatrix: this.texMatrix, u_tileMatrix: this.tileMatrix });
        renderer.draw();
    };
    return Tile;
}());
exports.Tile = Tile;


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("uniform    mat4   u_pvMatrix;\nuniform    mat4   u_mMatrix;\nuniform    mat3   u_texMatrix;\nuniform    mat3   u_tileMatrix;\nattribute  vec2   a_coord;\nvarying    vec2   v_tCoord;\n\n\nvoid main(void) {\n    v_tCoord = (u_texMatrix * vec3(a_coord, 1.)).xy;\n    vec4 position = u_mMatrix * vec4((u_tileMatrix * vec3(v_tCoord, 1.)).xy, 0., 1.);\n    // position.xyz /= vec3(length(position.xyz)); // for fd2u\n    gl_Position = u_pvMatrix * position;\n}\n");

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\n\nuniform    sampler2D  u_texture0;\nuniform    float      u_layer_alpha;\nuniform    float      u_alpha;\nvarying    vec2       v_tCoord;\n\nvoid main() {\n    u_layer_alpha;\n    gl_FragColor = texture2D(u_texture0, v_tCoord);\n    gl_FragColor.rgb *= u_layer_alpha;\n    gl_FragColor.a *= u_alpha;\n}\n");

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TileTexture = exports.SimpleImageTextureProvider = exports.AsyncTextureProvider = exports.TileRef = exports.TextureProvider = void 0;
var tslib_1 = __webpack_require__(0);
var gl_wrapper_1 = __webpack_require__(3);
var gl_matrix_1 = __webpack_require__(1);
var image_1 = __webpack_require__(6);
var math_1 = __webpack_require__(2);
var time_1 = __webpack_require__(62);
var tract_1 = __webpack_require__(14);
var TextureProvider = /** @class */ (function () {
    function TextureProvider(globe) {
        this.globe = globe;
        this.alreadyReleased = false;
        this._revision = 0;
    }
    TextureProvider.prototype.release = function () {
        this.alreadyReleased = true;
    };
    TextureProvider.prototype.visibleTracts = function (view, cb) {
        var fovCenter = view.camera.direction;
        var arc = view.camera.arc;
        var tractCount = 0;
        this.walkTracts(function (tract) {
            if (gl_matrix_1.vec3.sqrDist(fovCenter, tract.refPoint) <= math_1.square(arc + tract.fov)) {
                ++tractCount;
                cb(tract);
            }
        });
        return tractCount;
    };
    Object.defineProperty(TextureProvider.prototype, "revision", {
        get: function () {
            return this._revision;
        },
        enumerable: false,
        configurable: true
    });
    TextureProvider.prototype.update = function () {
        this._revision++;
    };
    return TextureProvider;
}());
exports.TextureProvider = TextureProvider;
var TileRef = /** @class */ (function () {
    function TileRef(id, priority) {
        this.id = id;
        this.priority = priority;
        var _a = tract_1.Tract.decodeTileId(id), tract = _a.tract, level = _a.level, p = _a.p, q = _a.q;
        this.tract = tract;
        this.level = level;
        this.p = p;
        this.q = q;
        var centerI = ((tract.tileSize << level) * (p + 0.5));
        var centerJ = ((tract.tileSize << level) * (q + 0.5));
        this.center = tract.pixel2xyz(centerJ, centerI);
    }
    return TileRef;
}());
exports.TileRef = TileRef;
var AsyncTextureProvider = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncTextureProvider, _super);
    function AsyncTextureProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.nParallel = 2;
        _this.loading = new Set();
        _this.requests = new Map();
        return _this;
    }
    AsyncTextureProvider.prototype.fetch = function (tileId, priority) {
        var _this = this;
        if (this.loading.has(tileId) || this.requests.has(tileId)) {
            return;
        }
        return new Promise(function (resolve, reject) {
            var ref = new TileRef(tileId, priority);
            _this.requests.set(tileId, { ref: ref, resolve: resolve, reject: reject });
        });
    };
    AsyncTextureProvider.prototype.flushQueue = function (center) {
        var _this = this;
        var rs = [];
        this.requests.forEach(function (v) { return rs.push(v); });
        rs.sort(function (a, b) {
            if (a.ref.priority !== b.ref.priority) {
                return a.ref.priority - b.ref.priority;
            }
            if (a.ref.level !== b.ref.level) {
                return b.ref.level - a.ref.level;
            }
            return gl_matrix_1.vec3.sqrDist(a.ref.center, center) - gl_matrix_1.vec3.sqrDist(b.ref.center, center);
        });
        var _loop_1 = function () {
            var _a = rs.shift(), ref = _a.ref, resolve = _a.resolve, reject = _a.reject;
            this_1.loading.add(ref.id);
            this_1.makeTileTexture(ref)
                .then(function (tt) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, time_1.nextAnimationFrame()];
                    case 1:
                        _a.sent();
                        resolve(tt);
                        return [2 /*return*/];
                }
            }); }); })
                .catch(function (e) { return reject(e); })
                .then(function () {
                _this.loading.delete(ref.id);
                if (_this.loading.size == 0) {
                    _this.globe.ee.emit('imageloadend');
                }
            });
        };
        var this_1 = this;
        while (rs.length > 0 && this.loading.size < this.nParallel) {
            _loop_1();
        }
        this.requests.clear();
    };
    AsyncTextureProvider.prototype.numLoadingImages = function () {
        return this.loading.size;
    };
    return AsyncTextureProvider;
}(TextureProvider));
exports.AsyncTextureProvider = AsyncTextureProvider;
var SimpleImageTextureProvider = /** @class */ (function (_super) {
    tslib_1.__extends(SimpleImageTextureProvider, _super);
    function SimpleImageTextureProvider(globe) {
        return _super.call(this, globe) || this;
    }
    SimpleImageTextureProvider.prototype.makeTileTexture = function (ref) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, image, tt, gl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.ref2url(ref);
                        return [4 /*yield*/, image_1.loadImage(url)];
                    case 1:
                        image = _a.sent();
                        tt = new TileTexture(this);
                        gl = this.globe.gl;
                        tt.bind(function () {
                            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
                            if (ref.level === ref.tract.maxTileLevel) {
                                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
                                gl.generateMipmap(gl.TEXTURE_2D);
                            }
                        });
                        return [2 /*return*/, tt];
                }
            });
        });
    };
    return SimpleImageTextureProvider;
}(AsyncTextureProvider));
exports.SimpleImageTextureProvider = SimpleImageTextureProvider;
var TileTexture = /** @class */ (function () {
    function TileTexture(tp) {
        this.tp = tp;
        this.fadeAlpha = 1;
        var gl = tp.globe.gl;
        this.tex = new gl_wrapper_1.Texture(gl);
        this.revision = tp.revision;
    }
    TileTexture.prototype.fadeIn = function () {
        var _this = this;
        this.tp.globe.animation((function (_a) {
            var r = _a.r;
            _this.fadeAlpha = r;
        }), { duration: 200, immediate: true });
    };
    TileTexture.prototype.release = function () {
        this.tex.release();
    };
    TileTexture.prototype.bind = function (cb) {
        this.tex.bind(cb);
    };
    TileTexture.prototype.needUpdate = function () {
        return this.revision < this.tp.revision;
    };
    return TileTexture;
}());
exports.TileTexture = TileTexture;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.nextAnimationFrame = exports.sleep = exports.time = void 0;
function time(name, cb) {
    var start = performance.now();
    var result = cb();
    console.log(name + ": " + (performance.now() - start));
    return result;
}
exports.time = time;
function sleep(t) {
    if (t === void 0) { t = 0; }
    return new Promise(function (resolve) { return setTimeout(resolve, t); });
}
exports.sleep = sleep;
exports.nextAnimationFrame = (function () {
    var q = [];
    var rafId;
    return function () { return new Promise(function (resolve) {
        q.push(resolve);
        if (rafId === undefined) {
            rafId = requestAnimationFrame(function () {
                rafId = undefined;
                q.forEach(function (r) { return r(); });
                q = [];
            });
        }
    }); };
})();


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Renderer = exports.BlendMode = exports.Path = exports.Point = exports.JOINT = void 0;
var tslib_1 = __webpack_require__(0);
var gl_wrapper_1 = __webpack_require__(3);
var gl_matrix_1 = __webpack_require__(1);
var JOINT;
(function (JOINT) {
    JOINT[JOINT["MITER"] = 0] = "MITER";
    JOINT[JOINT["NONE"] = 1] = "NONE";
})(JOINT = exports.JOINT || (exports.JOINT = {}));
var Point = /** @class */ (function () {
    function Point(position, color, size) {
        this.position = position;
        this.color = color;
        this.size = size;
    }
    return Point;
}());
exports.Point = Point;
var Path = /** @class */ (function () {
    function Path(points, close, joint) {
        if (joint === void 0) { joint = JOINT.NONE; }
        this.points = points;
        this.close = close;
        this.joint = joint;
    }
    return Path;
}());
exports.Path = Path;
var BlendMode;
(function (BlendMode) {
    BlendMode["NORMAL"] = "NORMAL";
    BlendMode["ADD"] = "ADD";
})(BlendMode = exports.BlendMode || (exports.BlendMode = {}));
var Renderer = /** @class */ (function () {
    function Renderer(gl) {
        this.gl = gl;
        this.darkenNarrowLine = true;
        this.depthTest = false;
        this.stencilTest = false;
        this.minWidth = 4;
        this.alpha = 1;
        this.blendMode = BlendMode.ADD;
        this._paths = [];
        this.alreadyReleased = false;
        this.needsUpdatePaths = false;
        this.program = gl_wrapper_1.Program.new(gl, __webpack_require__(64).default, __webpack_require__(65).default);
        this.attribList = new gl_wrapper_1.AttribList(gl, {
            members: [
                { name: 'a_p', nComponents: 3 },
                { name: 'a_a', nComponents: 3 },
                { name: 'a_b', nComponents: 3 },
                { name: 'a_y', nComponents: 1 },
                { name: 'a_width', nComponents: 1 },
                { name: 'a_color', nComponents: 4 },
            ],
        });
    }
    Renderer.prototype.setPaths = function (path) {
        this._paths = path.slice();
        this.needsUpdatePaths = true;
    };
    Renderer.prototype.release = function () {
        this.alreadyReleased = true;
        this.attribList.release();
        this.program.release();
    };
    Renderer.prototype.mMatirx = function () {
        return E;
    };
    Renderer.prototype.render = function (view) {
        var _this = this;
        if (this.needsUpdatePaths) {
            this.updateVBO();
            this.needsUpdatePaths = false;
        }
        if (this.attribList.vertexCount === 0) {
            return;
        }
        var alpha = this.alpha;
        if (alpha <= 0) {
            return;
        }
        var camera = view.camera;
        var gl = this.gl;
        var p = this.program;
        p.enableAttribList(this.attribList, function () {
            p.uniformMatrix4fv({ u_pvmMatrix: gl_matrix_1.mat4.mul(gl_matrix_1.mat4.create(), camera.pv, _this.mMatirx()) });
            p.uniform1f({
                u_alpha: alpha,
                u_fovy: camera.fovy,
                u_aspectRatio: camera.aspectRatio,
                u_minWidth: _this.minWidth / gl.drawingBufferHeight,
            });
            p.uniform1i({ u_darkenNarrowLine: _this.darkenNarrowLine ? 1 : 0 });
            var features = [gl.BLEND];
            var clearBit = 0;
            if (_this.stencilTest) {
                features.push(gl.STENCIL_TEST);
                clearBit |= gl.STENCIL_BUFFER_BIT;
                gl.clearStencil(0);
                gl.stencilFunc(gl.EQUAL, 0, ~0);
                gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
            }
            if (_this.depthTest) {
                features.push(gl.DEPTH_TEST);
                clearBit |= gl.DEPTH_BUFFER_BIT;
            }
            if (clearBit) {
                gl.clear(clearBit);
            }
            gl_wrapper_1.utils.enable(gl, features, function () {
                switch (_this.blendMode) {
                    case BlendMode.ADD:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case BlendMode.NORMAL:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                }
                gl.drawArrays(gl.TRIANGLE_STRIP, 0, _this.attribList.vertexCount);
            });
        });
    };
    Renderer.prototype.updateVBO = function () {
        var attrs = [];
        var paths = this._paths;
        for (var _i = 0, paths_1 = paths; _i < paths_1.length; _i++) {
            var path = paths_1[_i];
            switch (path.joint) {
                case JOINT.MITER:
                    path2attrsMiter(attrs, path);
                    break;
                case JOINT.NONE:
                    path2attrsNone(attrs, path);
                    break;
            }
        }
        this.attribList.setData({ array: new Float32Array(attrs) });
    };
    return Renderer;
}());
exports.Renderer = Renderer;
function path2attrsMiter(attrs, path) {
    if (path.points.length < 2) {
        throw new Error('Path must include more than 2 points');
    }
    if (path.close) {
        path.points.unshift(path.points[path.points.length - 1]);
        path.points.push(path.points[1], path.points[2]);
    }
    else {
        // cap ends
        path.points.unshift(tslib_1.__assign(tslib_1.__assign({}, path.points[0]), { position: path.points[0].position.map(function (p, i) { return 2 * p - path.points[1].position[i]; }) }));
        var last_1 = path.points.length - 1;
        path.points.push(tslib_1.__assign(tslib_1.__assign({}, path.points[last_1]), { position: path.points[last_1].position.map(function (p, i) { return 2 * p - path.points[last_1 - 1].position[i]; }) }));
    }
    for (var i = 1; i < path.points.length - 1; ++i) {
        // (a) - (p) - (b)
        var p = path.points[i];
        var a = path.points[i - 1];
        var b = path.points[i + 1];
        attrs.push.apply(attrs, tslib_1.__spreadArrays(p.position, a.position, b.position, [-1, 0.5 * p.size], p.color));
        if (i === 1) {
            attrs.push.apply(attrs, attrs.slice(attrs.length - 15));
        }
        attrs.push.apply(attrs, tslib_1.__spreadArrays(p.position, a.position, b.position, [+1, 0.5 * p.size], p.color));
    }
    attrs.push.apply(attrs, attrs.slice(attrs.length - 15));
}
function path2attrsNone(attrs, path) {
    if (path.points.length < 2) {
        throw new Error('Path must include more than 2 points');
    }
    if (path.close) {
        path.points.push(path.points[0]);
    }
    var _loop_1 = function (i) {
        var a = path.points[i];
        var b = path.points[i + 1];
        var a2 = [0, 1, 2].map(function (j) { return 2 * a.position[j] - b.position[j]; }); // a + (a - b)
        var b2 = [0, 1, 2].map(function (j) { return 2 * b.position[j] - a.position[j]; }); // b + (b - a)
        attrs.push.apply(// b + (b - a)
        attrs, tslib_1.__spreadArrays(a.position, a2, b.position, [+1, 0.5 * a.size], a.color));
        attrs.push.apply(attrs, tslib_1.__spreadArrays(a.position, a2, b.position, [+1, 0.5 * a.size], a.color));
        attrs.push.apply(attrs, tslib_1.__spreadArrays(a.position, a2, b.position, [-1, 0.5 * a.size], a.color));
        attrs.push.apply(attrs, tslib_1.__spreadArrays(b.position, a.position, b2, [+1, 0.5 * b.size], b.color));
        attrs.push.apply(attrs, tslib_1.__spreadArrays(b.position, a.position, b2, [-1, 0.5 * b.size], b.color));
        attrs.push.apply(attrs, tslib_1.__spreadArrays(b.position, a.position, b2, [-1, 0.5 * b.size], b.color));
    };
    for (var i = 0; i < path.points.length - 1; ++i) {
        _loop_1(i);
    }
}
var E = gl_matrix_1.mat4.create();


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\n\nuniform    mat4   u_pvmMatrix;\nuniform    float  u_aspectRatio;\nuniform    float  u_alpha;\nuniform    float  u_fovy;\nuniform    float  u_minWidth;\nuniform    int    u_darkenNarrowLine;\nattribute  vec3   a_p;\nattribute  vec3   a_a;\nattribute  vec3   a_b;\nattribute  float  a_y;\nattribute  float  a_width;\nattribute  vec4   a_color;\nvarying    vec4   v_color;\nvarying    float  v_y;\nvarying    float  v_w;\n\n\nvoid main(void) {\n    vec4 p4 = u_pvmMatrix * vec4(a_p, 1.);\n\n    vec4 a4 = u_pvmMatrix * vec4(a_a, 1.),\n         b4 = u_pvmMatrix * vec4(a_b, 1.);\n\n    vec2 a2 = (p4.w * a4.xy - a4.w * p4.xy) / (p4.w * p4.w),\n         b2 = (p4.w * b4.xy - b4.w * p4.xy) / (p4.w * p4.w);\n\n    a2.x *= u_aspectRatio;\n    b2.x *= u_aspectRatio;\n    a2 = normalize(a2);\n    b2 = normalize(b2);\n\n    vec2 t2 = normalize(b2 - a2),\n         v2 = vec2(-t2.y, t2.x);\n\n\tv_color = a_color;\n    v_color.a *= u_alpha;\n    u_alpha;\n\n    float cosecPhi = clamp(1. / (a2.y*v2.x - a2.x*v2.y), -2., 2.),\n          width = a_width / u_fovy,\n          minWidth = u_minWidth * p4.w;\n\n    if (width < minWidth) {\n        if (u_darkenNarrowLine == 1) {\n            v_color.a *= width / minWidth;\n        }\n        width = minWidth;\n    }\n\n    vec2 d2 = width * a_y * v2 * cosecPhi;\n    d2.x /= u_aspectRatio;\n    p4.xy += d2;\n    gl_Position = p4;\n\n    v_y = a_y;\n    v_w = gl_Position.w;\n}");

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\n\nuniform  float  u_fovy;\nvarying  vec4   v_color;\nvarying  float  v_y;\nvarying  float  v_w;\n\nvoid main() {\n    float alpha = 1. - smoothstep(0., 0.9, abs(v_y));\n    alpha *= clamp(4. * (v_w - 0.2), 0., 1.);\n    gl_FragColor = vec4(v_color.rgb, alpha * v_color.a);    \n}\n");

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.powerOf2 = exports.packRectsOptimally = exports.Rect = void 0;
var Rect = /** @class */ (function () {
    function Rect(width, height, position) {
        if (position === void 0) { position = [0, 0]; }
        this.width = width;
        this.height = height;
        this.position = position;
    }
    Object.defineProperty(Rect.prototype, "left", {
        get: function () { return this.position[0]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "top", {
        get: function () { return this.position[1]; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "right", {
        get: function () { return this.left + this.width; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "bottom", {
        get: function () { return this.top + this.height; },
        enumerable: false,
        configurable: true
    });
    Rect.prototype.intersect = function (other) {
        return (!(this.right <= other.left || this.left >= other.right) &&
            !(this.top >= other.bottom || this.bottom <= other.top));
    };
    return Rect;
}());
exports.Rect = Rect;
function packRects(rects, height) {
    rects = rects.slice().sort(function (a, b) { return a.height - b.height; });
    var packed = [];
    var cands = [[0, 0]];
    var _loop_1 = function () {
        var r = rects.pop();
        cands.sort(function (a, b) { return a[0] - b[0]; });
        for (var i = 0; i < cands.length; ++i) {
            var c = cands[i];
            r.position = c;
            if (r.bottom <= height && packed.every(function (p) { return !p.intersect(r); })) {
                packed.push(r);
                cands.splice(i, 1, [r.right, r.top], [r.left, r.bottom]);
                break;
            }
        }
    };
    while (rects.length > 0) {
        _loop_1();
    }
}
function packRectsOptimally(rects, maxSize) {
    var maxWidth = powerOf2(Math.max.apply(Math, rects.map(function (r) { return r.width; })));
    var height = powerOf2(Math.max.apply(Math, rects.map(function (r) { return r.height; })));
    var minArea = Infinity;
    var optimalHeight = -1;
    for (; true; height <<= 1) {
        var packed = packRects(rects, height);
        var width = powerOf2(Math.max.apply(Math, rects.map(function (r) { return r.right; })));
        if (width > maxSize) {
            continue;
        }
        var area = width * height;
        if (area < minArea) {
            minArea = area;
            optimalHeight = height;
        }
        if (width === maxWidth) {
            break;
        }
    }
    if (optimalHeight < 0) {
        throw new Error("Sprite Texture too large");
    }
    packRects(rects, optimalHeight);
}
exports.packRectsOptimally = packRectsOptimally;
function powerOf2(n) {
    var p = 1;
    while (p < n) {
        p *= 2;
    }
    return p;
}
exports.powerOf2 = powerOf2;


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("uniform    mat4   u_pvMatrix, u_mMatrix;\nuniform    float  u_width, u_height;\nattribute  vec3   a_vCoord;\nattribute  vec2   a_size, a_tCoord;\nvarying    vec2   v_tCoord;\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(a_vCoord, 1.);\n    gl_Position.x += a_size.x / u_width * gl_Position.w;\n    gl_Position.y += a_size.y / u_height * gl_Position.w;\n    v_tCoord = a_tCoord;\n}");

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\nuniform   sampler2D  u_texture;\nuniform   float      u_alpha;\nuniform   vec4       u_color;\nvarying   vec2       v_tCoord;\n\nvoid main() {\n    gl_FragColor = u_color * texture2D(u_texture, v_tCoord);\n    gl_FragColor.a *= u_alpha;\n}");

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstellationLayer = void 0;
var tslib_1 = __webpack_require__(0);
var layer_1 = __webpack_require__(4);
var path_renderer_1 = __webpack_require__(15);
var billboard_renderer_1 = __webpack_require__(30);
var angle_1 = __webpack_require__(5);
var text2imagedata_1 = __webpack_require__(32);
var japanese_1 = __webpack_require__(71);
var axios_1 = tslib_1.__importDefault(__webpack_require__(28));
var LANG;
(function (LANG) {
    LANG[LANG["ENGLISH"] = 0] = "ENGLISH";
    LANG[LANG["HIRAGANA"] = 1] = "HIRAGANA";
    LANG[LANG["KANJI"] = 2] = "KANJI";
})(LANG || (LANG = {}));
var ConstellationLayer = /** @class */ (function (_super) {
    tslib_1.__extends(ConstellationLayer, _super);
    function ConstellationLayer(showLines, showNames, lang) {
        if (showLines === void 0) { showLines = true; }
        if (showNames === void 0) { showNames = false; }
        if (lang === void 0) { lang = LANG.ENGLISH; }
        var _this = _super.call(this) || this;
        _this.showLines = showLines;
        _this.showNames = showNames;
        _this.lang = lang;
        _this.paths = [];
        _this.linesReady = false;
        _this.namesReady = false;
        return _this;
    }
    ConstellationLayer.prototype.onAdd = function () {
        this.pathRenderer = new path_renderer_1.Renderer(this.globe.gl);
        this.billboardRenderer = new billboard_renderer_1.BillboardRenderer(this.globe.gl);
        this.pathRenderer.setPaths(this.paths);
    };
    ConstellationLayer.prototype.onRemove = function () {
        this.pathRenderer.release();
        this.billboardRenderer.release();
    };
    ConstellationLayer.prototype.render = function (view) {
        var alpha = layer_1.Layer.overlayAlpha(view);
        if (this.showLines) {
            this.linesReady || this.buildLines();
            this.pathRenderer.alpha = alpha;
            this.pathRenderer.render(view);
        }
        if (this.showNames) {
            this.namesReady || this.buildNameBillboards();
            this.billboardRenderer.alpha = alpha;
            this.billboardRenderer.render(view);
        }
    };
    ConstellationLayer.prototype.buildLines = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var constellations, paths, _loop_1, _i, _a, name_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.linesReady = true;
                        return [4 /*yield*/, axios_1.default.get(__webpack_require__(33))];
                    case 1:
                        constellations = (_b.sent()).data;
                        paths = [];
                        _loop_1 = function (name_1) {
                            var c = constellations[name_1];
                            var name2star = (function () {
                                var m = {};
                                for (var _i = 0, _a = c.stars; _i < _a.length; _i++) {
                                    var star = _a[_i];
                                    m[star.name] = star;
                                }
                                return m;
                            })();
                            var color = c.ecliptical ? [1, 0.75, 0, 0.25] : [1, 1, 1, 0.25];
                            for (var _i = 0, _a = c.lines; _i < _a.length; _i++) {
                                var line = _a[_i];
                                var stars = line.split('-').map(function (starName) { return name2star[starName]; });
                                for (var i = 0; i < stars.length - 1; ++i) {
                                    var path = new path_renderer_1.Path([
                                        new path_renderer_1.Point(star2xyz(stars[i]), color, 0.015),
                                        new path_renderer_1.Point(star2xyz(stars[i + 1]), color, 0.015),
                                    ], false);
                                    paths.push(path);
                                }
                            }
                        };
                        for (_i = 0, _a = Object.keys(constellations); _i < _a.length; _i++) {
                            name_1 = _a[_i];
                            _loop_1(name_1);
                        }
                        this.pathRenderer.setPaths(this.paths = paths);
                        this.globe && this.globe.requestRefresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstellationLayer.prototype.buildNameBillboards = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var constellations, images, imageRefs, _i, _a, name_2, c, label;
            var _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.namesReady = true;
                        return [4 /*yield*/, axios_1.default.get(__webpack_require__(33))];
                    case 1:
                        constellations = (_c.sent()).data;
                        images = [];
                        imageRefs = [];
                        for (_i = 0, _a = Object.keys(constellations); _i < _a.length; _i++) {
                            name_2 = _a[_i];
                            c = constellations[name_2];
                            imageRefs.push({
                                imageID: images.length,
                                position: centroid(c.stars),
                            });
                            label = (_b = {},
                                _b[LANG.ENGLISH] = name_2,
                                _b[LANG.HIRAGANA] = japanese_1.hiragana[name_2],
                                _b[LANG.KANJI] = japanese_1.kanji[name_2],
                                _b)[this.lang];
                            images.push({
                                imageData: text2imagedata_1.text2imageData(label, '12pt fantasy', 'rgba(239, 225, 196, 1)'),
                                origin: [0, 0],
                            });
                        }
                        this.billboardRenderer.buildArray(images, imageRefs);
                        this.globe && this.globe.requestRefresh();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConstellationLayer.LANG = LANG;
    return ConstellationLayer;
}(layer_1.Layer));
exports.ConstellationLayer = ConstellationLayer;
function star2xyz(star) {
    var coord = angle_1.EquatorialCoord.fromDeg(star.ra, star.dec);
    return coord.xyz;
}
function centroid(stars) {
    var g = [0, 0, 0];
    for (var _i = 0, stars_1 = stars; _i < stars_1.length; _i++) {
        var s = stars_1[_i];
        star2xyz(s).forEach(function (c, i) { return g[i] += c; });
    }
    g = g.map(function (c) { return c / stars.length; });
    var r = Math.sqrt(g.reduce(function (sum, c) { return sum + c * c; }, 0));
    return g.map(function (c) { return c / r; });
}


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.elementSize = void 0;
var div = document.createElement('div');
div.style.position = 'fixed';
div.style.visibility = 'hidden';
function elementSize(cb) {
    cb(div);
    document.body.appendChild(div);
    var clientWidth = div.clientWidth, clientHeight = div.clientHeight;
    document.body.removeChild(div);
    return { width: clientWidth, height: clientHeight };
}
exports.elementSize = elementSize;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.hiragana = exports.kanji = void 0;
exports.kanji = {
    Andromeda: "アンドロメダ",
    Antlia: "ポンプ",
    Apus: "風鳥",
    Aquarius: "水瓶",
    Aquila: "鷲",
    Ara: "祭壇",
    Aries: "牡羊",
    Auriga: "御者",
    Boötes: "牛飼い",
    Caelum: "彫刻具",
    Camelopardalis: "キリン",
    Cancer: "蟹",
    CanesVenatici: "猟犬",
    CanisMajor: "大犬",
    CanisMinor: "小犬",
    Capricornus: "山羊",
    Carina: "竜骨",
    Cassiopeia: "カシオペヤ",
    Centaurus: "ケンタウルス",
    Cepheus: "ケフェウス",
    Cetus: "鯨",
    Chamaeleon: "カメレオン",
    Circinus: "コンパス",
    Columba: "鳩",
    ComaBerenices: "髪",
    CoronaAustralis: "南の冠",
    CoronaBorealis: "冠",
    Corvus: "烏",
    Crater: "コップ",
    Crux: "南十字",
    Cygnus: "白鳥",
    Delphinus: "海豚",
    Dorado: "旗魚",
    Draco: "竜",
    Equuleus: "小馬",
    Eridanus: "エリダヌス",
    Fornax: "炉",
    Gemini: "双子",
    Grus: "鶴",
    Hercules: "ヘルクレス",
    Horologium: "時計",
    Hydra: "海蛇",
    Hydrus: "水蛇",
    Indus: "インディアン",
    Lacerta: "蜥蜴",
    Leo: "獅子",
    LeoMinor: "小獅子",
    Lepus: "兎",
    Libra: "天秤",
    Lupus: "狼",
    Lynx: "山猫",
    Lyra: "琴",
    Mensa: "テーブル山",
    Microscopium: "顕微鏡",
    Monoceros: "一角獣",
    Musca: "蝿",
    Norma: "定規",
    Octans: "八分儀",
    Ophiuchus: "蛇遣",
    Orion: "オリオン",
    Pavo: "孔雀",
    Pegasus: "ペガスス",
    Perseus: "ペルセウス",
    Phoenix: "鳳凰",
    Pictor: "画架",
    Pisces: "魚",
    PiscisAustrinus: "南の魚",
    Puppis: "艫",
    Pyxis: "羅針盤",
    Reticulum: "レチクル",
    Sagitta: "矢",
    Sagittarius: "射手",
    Scorpius: "蠍",
    Sculptor: "彫刻室",
    Scutum: "楯",
    Serpens: "蛇",
    Sextans: "六分儀",
    Taurus: "牡牛",
    Telescopium: "望遠鏡",
    Triangulum: "三角",
    TriangulumAustrale: "南の三角",
    Tucana: "巨嘴鳥",
    UrsaMajor: "大熊",
    UrsaMinor: "小熊",
    Vela: "帆",
    Virgo: "乙女",
    Volans: "飛魚",
    Vulpecula: "小狐",
};
exports.hiragana = {
    Andromeda: "アンドロメダ",
    Antlia: "ポンプ",
    Apus: "ふうちょう",
    Aquarius: "みずがめ",
    Aquila: "わし",
    Ara: "さいだん",
    Aries: "おひつじ",
    Auriga: "ぎょしゃ",
    Boötes: "うしかい",
    Caelum: "ちょうこくぐ",
    Camelopardalis: "キリン",
    Cancer: "かに",
    CanesVenatici: "りょうけん",
    CanisMajor: "おおいぬ",
    CanisMinor: "こいぬ",
    Capricornus: "やぎ",
    Carina: "りゅうこつ",
    Cassiopeia: "カシオペヤ",
    Centaurus: "ケンタウルス",
    Cepheus: "ケフェウス",
    Cetus: "くじら",
    Chamaeleon: "カメレオン",
    Circinus: "コンパス",
    Columba: "はと",
    ComaBerenices: "かみのけ",
    CoronaAustralis: "みなみのかんむり",
    CoronaBorealis: "かんむり",
    Corvus: "からす",
    Crater: "コップ",
    Crux: "みなみじゅうじ",
    Cygnus: "はくちょう",
    Delphinus: "いるか",
    Dorado: "かじき",
    Draco: "りゅう",
    Equuleus: "こうま",
    Eridanus: "エリダヌス",
    Fornax: "ろ",
    Gemini: "ふたご",
    Grus: "つる",
    Hercules: "ヘルクレス",
    Horologium: "とけい",
    Hydra: "うみへび",
    Hydrus: "みずへび",
    Indus: "インディアン",
    Lacerta: "とかげ",
    Leo: "しし",
    LeoMinor: "こじし",
    Lepus: "うさぎ",
    Libra: "てんびん",
    Lupus: "おおかみ",
    Lynx: "やまねこ",
    Lyra: "こと",
    Mensa: "テーブルさん",
    Microscopium: "けんびきょう",
    Monoceros: "いっかくじゅう",
    Musca: "はえ",
    Norma: "じょうぎ",
    Octans: "はちぶんぎ",
    Ophiuchus: "へびつかい",
    Orion: "オリオン",
    Pavo: "くじゃく",
    Pegasus: "ペガスス",
    Perseus: "ペルセウス",
    Phoenix: "ほうおう",
    Pictor: "がか",
    Pisces: "うお",
    PiscisAustrinus: "みなみのうお",
    Puppis: "とも",
    Pyxis: "らしんばん",
    Reticulum: "レチクル",
    Sagitta: "や",
    Sagittarius: "いて",
    Scorpius: "さそり",
    Sculptor: "ちょうこくしつ",
    Scutum: "たて",
    Serpens: "へび",
    Sextans: "ろくぶんぎ",
    Taurus: "おうし",
    Telescopium: "ぼうえんきょう",
    Triangulum: "さんかく",
    TriangulumAustrale: "みなみのさんかく",
    Tucana: "きょしちょう",
    UrsaMajor: "おおぐま",
    UrsaMinor: "こぐま",
    Vela: "ほ",
    Virgo: "おとめ",
    Volans: "とびうお",
    Vulpecula: "こぎつね",
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.HipparcosCatalogLayer = void 0;
var tslib_1 = __webpack_require__(0);
var layer_1 = __webpack_require__(4);
var point_renderer_1 = __webpack_require__(73);
// tslint:disable-next-line:no-var-requires variable-name
var Loader = __webpack_require__(76);
var HipparcosCatalogLayer = /** @class */ (function (_super) {
    tslib_1.__extends(HipparcosCatalogLayer, _super);
    function HipparcosCatalogLayer() {
        var _this = _super.call(this) || this;
        _this.loader = new Loader();
        _this.loader.addEventListener('message', function (e) {
            _this.array = new Float32Array(e.data.buffer);
            _this.refresh();
        });
        return _this;
    }
    HipparcosCatalogLayer.prototype.onAdd = function () {
        this.pointRenderer = new point_renderer_1.PointRenderer(this.globe.gl);
        this.refresh();
    };
    HipparcosCatalogLayer.prototype.onRemove = function () {
        this.pointRenderer.release();
    };
    HipparcosCatalogLayer.prototype.render = function (view) {
        this.pointRenderer.alpha = layer_1.Layer.overlayAlpha(view);
        this.pointRenderer.render(view);
    };
    HipparcosCatalogLayer.prototype.refresh = function () {
        if (this.globe && this.pointRenderer && this.array) {
            this.pointRenderer._setArray(this.array);
            this.globe.requestRefresh();
        }
    };
    return HipparcosCatalogLayer;
}(layer_1.Layer));
exports.HipparcosCatalogLayer = HipparcosCatalogLayer;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PointRenderer = exports.Point = void 0;
var tslib_1 = __webpack_require__(0);
var gl_wrapper_1 = __webpack_require__(3);
var Point = /** @class */ (function () {
    function Point(position, color, size) {
        this.position = position;
        this.color = color;
        this.size = size;
    }
    return Point;
}());
exports.Point = Point;
var PointRenderer = /** @class */ (function () {
    function PointRenderer(gl) {
        this.gl = gl;
        this.darkenSmallPoint = true;
        this.minSize = 3;
        this.alpha = 1;
        this._points = [];
        this.needsUpdatePoints = false;
        this.program = gl_wrapper_1.Program.new(gl, __webpack_require__(74).default, __webpack_require__(75).default);
        this.attribList = new gl_wrapper_1.AttribList(gl, {
            members: [
                { name: 'a_position', nComponents: 3 },
                { name: 'a_size', nComponents: 1 },
                { name: 'a_color', nComponents: 4 },
            ],
        });
    }
    Object.defineProperty(PointRenderer.prototype, "points", {
        get: function () { return this.points; },
        set: function (points) {
            this._points = points;
            this.needsUpdatePoints = true;
        },
        enumerable: false,
        configurable: true
    });
    PointRenderer.prototype.release = function () {
        this.attribList.release();
        this.program.release();
    };
    PointRenderer.prototype.render = function (view) {
        var _this = this;
        if (this.needsUpdatePoints) {
            this.updateVBO();
            this.needsUpdatePoints = false;
        }
        if (this.attribList.vertexCount === 0) {
            return;
        }
        var alpha = this.alpha;
        if (alpha <= 0) {
            return;
        }
        var camera = view.camera;
        var gl = this.gl;
        var p = this.program;
        p.enableAttribList(this.attribList, function () {
            p.uniformMatrix4fv({ u_pvMatrix: camera.pv });
            p.uniform1f({
                u_alpha: alpha,
                u_fovy: camera.fovy,
                u_bufferHeight: gl.drawingBufferHeight,
                u_minSize: _this.minSize,
            });
            p.uniform1i({ u_darkenSmallPoint: _this.darkenSmallPoint ? 1 : 0 });
            gl_wrapper_1.utils.enable(gl, [gl.BLEND], function () {
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                gl.drawArrays(gl.POINTS, 0, _this.attribList.vertexCount);
            });
        });
    };
    PointRenderer.prototype.updateVBO = function () {
        /*
          { name: 'a_position', nComponents: 3 },
          { name: 'a_size', nComponents: 1 },
          { name: 'a_color', nComponents: 4 },
        */
        var attrs = [];
        var points = this._points;
        for (var _i = 0, points_1 = points; _i < points_1.length; _i++) {
            var p = points_1[_i];
            attrs.push.apply(attrs, tslib_1.__spreadArrays(p.position, [p.size], p.color));
        }
        this.attribList.setData({ array: new Float32Array(attrs) });
    };
    PointRenderer.prototype._setArray = function (array) {
        this._points = [];
        this.attribList.setData({ array: new Float32Array(array) });
    };
    return PointRenderer;
}());
exports.PointRenderer = PointRenderer;


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("uniform    mat4   u_pvMatrix;\nuniform    float  u_minSize;\nuniform    float  u_alpha;\nuniform    float  u_fovy;\nuniform    float  u_bufferHeight;\nuniform    int    u_darkenSmallPoint;\nattribute  vec3   a_position;\nattribute  float  a_size;\nattribute  vec4   a_color;\nvarying    vec4   v_color;\nvarying    float  v_w;\n\n\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(a_position, 1.);\n    float pointSize = u_bufferHeight * a_size / (gl_Position.w * u_fovy);\n    float screenSize = max(pointSize, u_minSize);\n    float r = pointSize / screenSize;\n    v_color = a_color;\n    v_color.a *= u_darkenSmallPoint != 0 ? u_alpha * r * r : u_alpha;\n    gl_PointSize = screenSize;\n    v_w = gl_Position.w;\n}");

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\nvarying   vec4   v_color;\nvarying   float  v_w;\n\n\nvoid main() {\n    float r = 2. * length(gl_PointCoord - vec2(0.5));\n    float v = (1. - smoothstep(0.6, 1.0, r)) * clamp(4. * (v_w - 0.2), 0., 1.);\n    gl_FragColor = v_color;\n    gl_FragColor.a *= v;\n}");

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "2e0a14168a5f0fa5f55c.worker.js");
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLayer = void 0;
var tslib_1 = __webpack_require__(0);
// tslint:disable:variable-name
var layer_1 = __webpack_require__(4);
var path_renderer_1 = __webpack_require__(15);
var math_1 = __webpack_require__(2);
var GridLayer = /** @class */ (function (_super) {
    tslib_1.__extends(GridLayer, _super);
    function GridLayer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridLayer.prototype.onAdd = function () {
        this.pathRenderer = new path_renderer_1.Renderer(this.globe.gl);
        this.pathRenderer.setPaths(this.generatePaths());
    };
    GridLayer.prototype.onRemove = function () {
        this.pathRenderer.release();
    };
    GridLayer.prototype.render = function (view) {
        this.pathRenderer.alpha = layer_1.Layer.overlayAlpha(view);
        this.pathRenderer.render(view);
    };
    GridLayer.prototype.generatePaths = function () {
        var paths = [];
        var width = 0.008;
        var defaultColor = [0.25, 0.5, 1, 0.5];
        var n_d;
        var n_a;
        // decl lines
        n_d = 18;
        n_a = 360;
        var _loop_1 = function (i_d) {
            var theta = Math.PI * (i_d - 9) / n_d;
            var color = i_d === 9 ? [1, 0, 0, 0.75] : defaultColor;
            paths.push(new path_renderer_1.Path(math_1.range(0, n_a).map(function (i_a) {
                var phi = 2 * Math.PI * i_a / n_a;
                return new path_renderer_1.Point([
                    Math.cos(theta) * Math.cos(phi),
                    Math.cos(theta) * Math.sin(phi),
                    Math.sin(theta)
                ], color, width);
            }), true, path_renderer_1.JOINT.MITER));
        };
        for (var i_d = 1; i_d < n_d; ++i_d) {
            _loop_1(i_d);
        }
        // ra lines
        n_d = 180;
        n_a = 24;
        var _loop_2 = function (i_a) {
            var phi = 2 * Math.PI * i_a / n_a;
            var color = {
                0: [1, 0, 0, 0.5],
                6: [0.5, 1, 0, 0.5],
                12: [0, 1, 1, 0.5],
                18: [0.5, 0, 1, 0.5],
            }[i_a] || defaultColor;
            paths.push(new path_renderer_1.Path(math_1.range(0, n_d + 1).map(function (i_d) {
                var theta = Math.PI * (i_d - 90) / n_d;
                return new path_renderer_1.Point([
                    Math.cos(theta) * Math.cos(phi),
                    Math.cos(theta) * Math.sin(phi),
                    Math.sin(theta)
                ], color, width);
            }), false, path_renderer_1.JOINT.MITER));
        };
        for (var i_a = 0; i_a < n_a; ++i_a) {
            _loop_2(i_a);
        }
        return paths;
    };
    return GridLayer;
}(layer_1.Layer));
exports.GridLayer = GridLayer;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EsoMilkyWayLayer = void 0;
var tslib_1 = __webpack_require__(0);
var cube_map_renderer_1 = __webpack_require__(79);
var gl_matrix_1 = __webpack_require__(1);
var image_1 = __webpack_require__(6);
var __1 = __webpack_require__(8);
// thanks to ESO/S. Brunier
// https://www.eso.org/public/images/eso0932a/
var EsoMilkyWayLayer = /** @class */ (function (_super) {
    tslib_1.__extends(EsoMilkyWayLayer, _super);
    function EsoMilkyWayLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fadeAlpha = 0;
        return _this;
    }
    EsoMilkyWayLayer.prototype.onAdd = function () {
        var _this = this;
        this.renderer = new EsoMilkyWay(this.globe.gl, function () {
            _this.globe && _this.globe.animation(function (_a) {
                var r = _a.r;
                _this.fadeAlpha = r;
            }, { duration: 200 });
        });
    };
    EsoMilkyWayLayer.prototype.onRemove = function () {
        this.renderer.release();
    };
    EsoMilkyWayLayer.prototype.render = function (view) {
        var alpha = __1.Layer.overlayAlpha(view) * this.fadeAlpha;
        this.renderer.alpha = alpha;
        this.renderer.render(view);
    };
    return EsoMilkyWayLayer;
}(__1.Layer));
exports.EsoMilkyWayLayer = EsoMilkyWayLayer;
var EsoMilkyWay = /** @class */ (function (_super) {
    tslib_1.__extends(EsoMilkyWay, _super);
    function EsoMilkyWay(gl, done) {
        var _this = _super.call(this, gl) || this;
        _this.m = gl_matrix_1.mat4.fromValues(+0.0017373464070261, -0.4792437255382538, -0.8776800036430359, 0, +0.8911036849021912, +0.3990314602851868, -0.2161209583282471, 0, +0.4537965655326843, -0.7817283272743225, +0.4277492463588715, 0, 0, 0, 0, 1);
        _this.loadImages().then(done);
        return _this;
    }
    EsoMilkyWay.prototype.loadImages = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var urls, isFirefox, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isFirefox = window.navigator.userAgent.match(/firefox/i);
                        if (isFirefox) {
                            urls = urls512;
                            console.info('using small version of ESO Milky Way images');
                        }
                        else {
                            urls = urls1024;
                        }
                        _a = this.setCubeImage;
                        return [4 /*yield*/, Promise.all(urls.map(function (url) { return image_1.loadImage(url); }))];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        });
    };
    EsoMilkyWay.prototype.mMatrix = function () {
        return this.m;
    };
    EsoMilkyWay.attributions = [{
            which: 'The Milky Way Panorama',
            label: 'ESO/S. Brunier',
            link: 'https://www.eso.org/public/images/eso0932a/',
        }];
    return EsoMilkyWay;
}(cube_map_renderer_1.CubeMappRenderer));
var urls1024 = ['px', 'py', 'pz', 'nx', 'ny', 'nz']
    .map(function (dir) { return "//hscmap.mtk.nao.ac.jp/data/eso_milky_way_layer/images-1024/" + dir + ".png"; });
var urls512 = ['px', 'py', 'pz', 'nx', 'ny', 'nz']
    .map(function (dir) { return "//hscmap.mtk.nao.ac.jp/data/eso_milky_way_layer/images-512/" + dir + ".png"; });


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CubeMappRenderer = void 0;
var gl_wrapper_1 = __webpack_require__(3);
var gl_matrix_1 = __webpack_require__(1);
var CubeMappRenderer = /** @class */ (function () {
    function CubeMappRenderer(gl) {
        this.gl = gl;
        this.alpha = 1;
        this.program = gl_wrapper_1.Program.new(gl, __webpack_require__(80).default, __webpack_require__(81).default);
        this.buildArray();
    }
    CubeMappRenderer.prototype.release = function () {
        this.program.release();
        this.attribList.release();
        this.indexBuffer.release();
        this.texture && this.gl.deleteTexture(this.texture);
    };
    CubeMappRenderer.prototype.render = function (view) {
        var _this = this;
        if (this.texture === undefined) {
            return;
        }
        var alpha = this.alpha;
        if (alpha <= 0) {
            return;
        }
        var p = this.program;
        var gl = this.gl;
        p.use();
        p.enableAttribList(this.attribList, function () {
            p.uniform1i({ u_cubeTexture: 0 });
            p.uniformMatrix4fv({ u_pvMatrix: view.camera.pv, u_mMatrix: _this.mMatrix() });
            p.uniform3fv({ u_eyePosition: view.camera.eyePosition });
            p.uniform1f({
                u_alpha: alpha,
                u_radius: 1,
            });
            gl_wrapper_1.utils.enable(gl, [gl.BLEND, gl.CULL_FACE], function () {
                gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                _this.indexBuffer.bind(function () {
                    gl.bindTexture(gl.TEXTURE_CUBE_MAP, _this.texture);
                    gl.drawElements(gl.TRIANGLES, _this.indexBuffer.length, gl.UNSIGNED_SHORT, 0);
                    gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
                });
            });
        });
    };
    CubeMappRenderer.prototype.mMatrix = function () {
        return E;
    };
    CubeMappRenderer.prototype.buildArray = function () {
        this.attribList = new gl_wrapper_1.AttribList(this.gl, {
            members: [
                { name: 'a_position', nComponents: 3 },
            ],
            array: new Float32Array([
                -1, -1, -1,
                -1, -1, +1,
                -1, +1, -1,
                -1, +1, +1,
                +1, -1, -1,
                +1, -1, +1,
                +1, +1, -1,
                +1, +1, +1,
            ]),
        });
        this.indexBuffer = new gl_wrapper_1.IndexBuffer(this.gl, {
            array: new Int16Array([
                1, 0, 2, 1, 2, 3,
                1, 7, 5, 1, 3, 7,
                5, 7, 6, 4, 5, 6,
                3, 6, 7, 2, 6, 3,
                0, 6, 2, 0, 4, 6,
                0, 1, 5, 0, 5, 4,
            ]),
        });
    };
    CubeMappRenderer.prototype.setupTexture = function () {
        var gl = this.gl;
        this.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.texture);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
    };
    CubeMappRenderer.prototype.setCubeImage = function (images) {
        this.texture || this.setupTexture();
        var gl = this.gl;
        var targets = [
            gl.TEXTURE_CUBE_MAP_POSITIVE_X,
            gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
            gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Z,
        ];
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, this.texture);
        for (var i = 0; i < targets.length; ++i) {
            gl.texImage2D(targets[i], 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, images[i]);
        }
        gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
        gl.bindTexture(gl.TEXTURE_CUBE_MAP, null);
    };
    CubeMappRenderer.faces = ['px', 'py', 'pz', 'nx', 'ny', 'nz'];
    return CubeMappRenderer;
}());
exports.CubeMappRenderer = CubeMappRenderer;
var E = gl_matrix_1.mat4.create();


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\n\nuniform    mat4          u_pvMatrix;\nuniform    float         u_radius;\nattribute  vec3          a_position;\nvarying    vec3          v_position;\n\nvoid main(void) {\n    gl_Position = u_pvMatrix * vec4(u_radius * a_position, 1.);\n    v_position = u_radius * a_position;\n}");

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("precision mediump float;\n\nuniform    samplerCube   u_cubeTexture;\nuniform    mat4          u_mMatrix;\nuniform    float         u_radius;\nuniform    float         u_alpha;\nuniform    vec3          u_eyePosition;\nvarying    vec3          v_position;\n\nvoid main() {\n    vec3 d = v_position - u_eyePosition;\n    float a = dot(d, d),\n          b = 2. * dot(u_eyePosition, d),\n          c = dot(u_eyePosition, u_eyePosition) - u_radius*u_radius,\n          D = b*b - 4.*a*c,\n          t1, t2;\n    if (D < 0.)\n        discard;\n    t1 = (-b + sqrt(D)) / (2.*a);\n    t2 = (-b - sqrt(D)) / (2.*a);\n    vec3 dir1 = u_eyePosition + t1*d;\n    vec3 dir2 = u_eyePosition + t2*d;\n    float z = t2 * length(d);\n    gl_FragColor = textureCube(u_cubeTexture, (u_mMatrix * vec4(dir1, 1.)).yzx) +\n                   vec4(vec3(smoothstep(0., 1., z)), 0.) * textureCube(u_cubeTexture, (u_mMatrix * vec4(dir2, 1.)).yzx);\n\n    gl_FragColor.rgb = pow(gl_FragColor.rgb, vec3(1.));\n    // gl_FragColor = textureCube(u_cubeTexture, (u_mMatrix * vec4(dir1, 1.)).yzx);\n    gl_FragColor.a *= u_alpha;\n}");

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var functional_1 = __webpack_require__(83);
Object.defineProperty(exports, "debounce", { enumerable: true, get: function () { return functional_1.debounce; } });
Object.defineProperty(exports, "throttle", { enumerable: true, get: function () { return functional_1.throttle; } });
var image_1 = __webpack_require__(6);
Object.defineProperty(exports, "loadImage", { enumerable: true, get: function () { return image_1.loadImage; } });
var serial_number_1 = __webpack_require__(29);
Object.defineProperty(exports, "serialNumber", { enumerable: true, get: function () { return serial_number_1.serialNumber; } });


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = exports.throttle = void 0;
function throttle(delay, cb) {
    var timer;
    var f = function () {
        if (timer === undefined) {
            timer = setTimeout(function () {
                timer = undefined;
                cb();
            }, delay);
        }
    };
    return f;
}
exports.throttle = throttle;
function debounce(delay, cb) {
    var timer;
    var f = function () {
        if (timer !== undefined) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = undefined;
            cb();
        }, delay);
    };
    return f;
}
exports.debounce = debounce;


/***/ })
/******/ ])));